//#region Variables
const RESULTS_PER_PAGE =30;
const DEFAULT_DIAMOND_IMAGE = 'https://cdn.shopify.com/s/files/1/0591/3663/9116/files/NoImage.png?v=1658497347';

let filters = {};

let wishList=[];
let priceSlider = document.getElementById('slider-price');
let caratSlider = document.getElementById('slider-carat');
let colorSlider = document.getElementById('slider-color');
let claritySlider = document.getElementById('slider-clarity');
let cutSlider = document.getElementById('slider-cut');
let ratioSlider = document.getElementById('slider-ratio');
let polishSlider = document.getElementById('slider-polish');
let fluorSlider = document.getElementById('slider-fluor');
let symmetrySlider = document.getElementById('slider-symmetry');
let depthSlider = document.getElementById('slider-depth');
let tableSlider = document.getElementById('slider-table');
let currentCurrency = Shopify.currency.active;
let currentCurrencySymbol = $('body').attr('data-currency');
let currentRate = window.Shopify.currency.rate;
let typeView;

let initFiltValues = {
    price: [25, 463580],
    carat: [0.25, 11.58],
    color: [0, 8],
    clarity: [0, 8],
    cut: [0, 6],
    ratio: [1, 2.75],
    polish: [0, 4],
    fluor: [0, 4],
    symmetry: [0, 4],
    depth: [1, 94.30],
    table: [45, 87]
};
let timer;
const delay = 500;


//#endregion

//#region Create NoUI Filters

function createFilters() {
    noUiSlider.create(priceSlider, {
        connect: true,
        start: initFiltValues.price,
        step: 1,
        range: {
            'min': initFiltValues.price[0],
            'max': initFiltValues.price[1]
        },
        margin:10
    });
    // Let's create the carat's filter, if the wizard started form a setting then the boundaries are setted by the setting
    // otherwise the boundaries are setted by the default values
    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo')); 
  
    let wizardStart;
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let min_allowed_carat =  initFiltValues.carat[0];
    let max_allowed_carat = initFiltValues.carat[1];

    let allowed_shapes = [];
    if(wizardInfo != null){
    if(wizardInfo.setting_max_carat_size != null && wizardInfo.setting_min_carat_size != null){
       if(wizardInfo.setting_max_carat_size !=0 || wizardInfo.setting_min_carat_size != 0){
        max_allowed_carat = parseFloat(wizardInfo.setting_max_carat_size) + 0.10;
        min_allowed_carat = parseFloat(wizardInfo.setting_min_carat_size) - 0.10;
        allowed_shapes = wizardInfo.setting_allowed_shapes;
        initFiltValues.carat[0] = min_allowed_carat;
        initFiltValues.carat[1] = max_allowed_carat;
       }
    }
    }

    noUiSlider.create(caratSlider, {
        connect: true,
        start: initFiltValues.carat,
        range: {
            'min': min_allowed_carat,
            'max': max_allowed_carat
        },
        margin:0.10
    });

    noUiSlider.create(colorSlider, {
        connect: true,
        range: {
            'min': [0, 1],
            '14.28%': [1, 2],
            '28.56%': [2, 3],
            '42.84%': [3, 4],
            '57.12%': [4, 5],
            '71.40%': [5, 6],
            '85.68%': [6, 7],
            'max': [7, 8]
        },
        margin: 1,
        start: initFiltValues.color
    });

    noUiSlider.create(claritySlider, {
        connect: true,
        range: {
            'min': [0, 1],
            '14.28%': [1, 2],
            '28.56%': [2, 3],
            '42.84%': [3, 4],
            '57.12%': [4, 5],
            '71.40%': [5, 6],
            '85.68%': [6, 7],
            'max': [7, 8]
        },
        margin: 1,
        start: initFiltValues.clarity
    });

    noUiSlider.create(cutSlider, {
        connect: true,
        range: {
            'min': [0, 1],
            '20%': [1, 2],
            '40%': [2, 3],
            '60%': [3, 4],
            '80%': [4, 5],
            'max': [5, 6]
        },
        margin: 1,
        start: initFiltValues.cut
    });

    noUiSlider.create(ratioSlider, {
        connect: true,
        start: initFiltValues.ratio,
        range: {
            'min': initFiltValues.ratio[0],
            'max': initFiltValues.ratio[1]
        },
        margin:0.10
    });

    noUiSlider.create(polishSlider, {
        connect: true,
        range: {
            'min': [0, 1],
            '33.33%': [1, 2],
            '66.66%': [2, 3],
            'max': [3, 4],
        },
        margin: 1,
        start: initFiltValues.polish
    });

    noUiSlider.create(fluorSlider, {
        connect: true,
        range: {
            'min': [0, 1],
            '33.33%': [1, 2],
            '66.66%': [2, 3],
            'max': [3, 4],
        },
        margin: 1,
        start: initFiltValues.fluor
    });

    noUiSlider.create(symmetrySlider, {
        connect: true,
        range: {
            'min': [0, 1],
            '33.33%': [1, 2],
            '66.66%': [2, 3],
            'max': [3, 4],
        },
        margin: 1,
        start: initFiltValues.symmetry
    });

    noUiSlider.create(depthSlider, {
        connect: true,
        start: initFiltValues.depth,
        range: {
            'min': initFiltValues.depth[0],
            'max': initFiltValues.depth[1]
        }
    });

    noUiSlider.create(tableSlider, {
        connect: true,
        start: initFiltValues.table,
        range: {
            'min': initFiltValues.table[0],
            'max': initFiltValues.table[1]
        },
        margin:0.1
    });

    if(wizardInfo){
        //Let's check if there's a setting selected and hide the shapes that are not allowed by the setting
        if(wizardInfo.setting_allowed_shapes != null && wizardInfo.setting_allowed_shapes.length > 0){
            let shapes = document.getElementsByClassName('shape-container-2');
            for (let i = 0; i < shapes.length; i++) {
                //get the shape name after shape-container- string in the id of the element
                let shapeName = shapes[i].id.substring(16);
                let shapeNameCapitalized = shapeName.charAt(0).toUpperCase() + shapeName.slice(1);
                let shape = shapes[i];
                if(!wizardInfo.setting_allowed_shapes.includes(shapeNameCapitalized)){
                    shape.style.display = 'none';
                }
            }
        }
    }
}

//#endregion

//#Utils for images and V360
function isImage(url) {
    if(url === undefined || url === null) return false;
    return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
}

function isV360(url){
    if(url.indexOf('360') > -1){
        return true;
    }
    else{
        return false;
    }
}

function getDiamondImageUrl(diamond){
    if(isImage(diamond.image_url)){
        return `<img src='${diamond.image_url}' loading="lazy"/>`;
    }       
    else{
        if(isV360(diamond.image_url)){
            //set the innerHTML to an iframe loading diamond.Image_URL
            return `<iframe data-src="${diamond.image_url}" src="" scrolling="no" width=420 height=420 sandbox="allow-scripts allow-orientation-lock allow-same-origin allow-pointer-lock"></iframe>`;        
        }
        else {
            return `<img src='${getDiamondLinesImgTableResults(diamond.shape)}'  loading="lazy">`;
        }
    }
}


//#region Formats

function formatPrice(value, revert = false) {

    let format = wNumb({
        decimals: 0,
        thousand: ',',
        prefix: '$'
    });

    if (revert) {
        return format.from(value);
    }

    return format.to(value);
}

function formatPercentage(value, revert = false) {

    let format = wNumb({
        decimals: 2,
        mark: '.',
        suffix: ' %'
    });

    if (revert) {
        return format.from(value);
    }

    return format.to(value);
}

function toCurrencyFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits:2, maximumFractionDigits: 2});
}

function toNumberFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"decimal", minimumFractionDigits:2, maximumFractionDigits: 2});
}

//#endregion

//#region Bind Events

function bindEventsPrice() {

    priceSlider.noUiSlider.on('update', function (values) {
   
        document.getElementById('price-min').value = currentCurrencySymbol+''+toNumberFormat(values[0] * currentRate);
        document.getElementById('price-max').value = currentCurrencySymbol+''+toNumberFormat(values[1] * currentRate);
    });

    priceSlider.noUiSlider.on('change', () => {
        getPriceFilterValues();
        getResults();
    });

    document.getElementById('price-min').addEventListener('change', (e) => {
        priceSlider.noUiSlider.set([formatPrice(e.target.value, true), null]);
        getPriceFilterValues();
        getResults();
    });

    document.getElementById('price-max').addEventListener('change', (e) => {
        priceSlider.noUiSlider.set([null, formatPrice(e.target.value, true)]);
        getPriceFilterValues();
        getResults();
    });
}

function bindEventsCarat() {
    caratSlider.noUiSlider.on('update', function (values) {
        document.getElementById('carat-min').value = values[0];
        document.getElementById('carat-max').value = values[1];
    });

    caratSlider.noUiSlider.on('change', () => {
        getCaratFilterValues();
        getResults();
    });

    document.getElementById('carat-min').addEventListener('change', (e) => {
        caratSlider.noUiSlider.set([e.target.value, null]);
        getCaratFilterValues();
        getResults();
    });

    document.getElementById('carat-max').addEventListener('change', (e) => {
        caratSlider.noUiSlider.set([null, e.target.value]);
        getCaratFilterValues();
        getResults();
    });
}

function bindEventsClarity() {
    claritySlider.noUiSlider.on('change', () => {
        getClarityFilterValues();
        getResults();
    });
}

function bindEventsColor() {
    colorSlider.noUiSlider.on('change', () => {
        getColorFilterValues();
        getResults();
    });
}

function bindEventsRatio() {
    ratioSlider.noUiSlider.on('update', function (values) {
        document.getElementById('ratio-min').value = values[0];
        document.getElementById('ratio-max').value = values[1];
    });

    ratioSlider.noUiSlider.on('change', () => {
        getRatioFilterValues();
        getResults();
    });

    document.getElementById('ratio-min').addEventListener('change', (e) => {
        ratioSlider.noUiSlider.set([e.target.value, null]);
        getRatioFilterValues();
        getResults();
    });

    document.getElementById('ratio-max').addEventListener('change', (e) => {
        ratioSlider.noUiSlider.set([null, e.target.value]);
        getRatioFilterValues();
        getResults();
    });
}

function bindEventsCut() {
    cutSlider.noUiSlider.on('change', () => {
        getCutFilterValues();
        getResults();
    });
}

function bindEventsFluor() {
    fluorSlider.noUiSlider.on('change', () => {
        getFluorFilterValues();
        getResults();
    });
}

function bindEventsSymmetry() {
    symmetrySlider.noUiSlider.on('change', () => {
        getSymmetryFilterValues();
        getResults();
    });
}

function bindEventsPolish() {
    polishSlider.noUiSlider.on('change', () => {
        getPolishFilterValues();
        getResults();
      
    });
}

function bindEventsDepth() {
    depthSlider.noUiSlider.on('update', function (values) {
        document.getElementById('depth-min').value = formatPercentage(parseFloat(values[0]));
        document.getElementById('depth-max').value = formatPercentage(parseFloat(values[1]));
    });

    depthSlider.noUiSlider.on('change', () => {
        getDepthFilterValues();
        getResults();
    });

    document.getElementById('depth-min').addEventListener('change', (e) => {
        depthSlider.noUiSlider.set([formatPercentage(e.target.value, true), null]);
        getDepthFilterValues();
        getResults();
    });

    document.getElementById('depth-max').addEventListener('change', (e) => {
        depthSlider.noUiSlider.set([null, formatPercentage(e.target.value, true)]);
        getDepthFilterValues();
        getResults();
    });
}

function bindEventsTable() {
    tableSlider.noUiSlider.on('update', function (values) {
        document.getElementById('table-min').value = formatPercentage(parseFloat(values[0]));
        document.getElementById('table-max').value = formatPercentage(parseFloat(values[1]));
    });

    tableSlider.noUiSlider.on('change', () => {
        getTableFilterValues();
        getResults();
    });

    document.getElementById('table-min').addEventListener('change', (e) => {
        tableSlider.noUiSlider.set([formatPercentage(e.target.value, true), null]);
        getTableFilterValues();
        getResults();
    });

    document.getElementById('table-max').addEventListener('change', (e) => {
        tableSlider.noUiSlider.set([null, formatPercentage(e.target.value, true)]);
        getTableFilterValues();
        getResults();
    });
}

function bindEventsGrading() {
    document.getElementById('grading-gia').addEventListener('change', () => {
        getGradingFilterValues();
        getResults();
    });

    document.getElementById('grading-igi').addEventListener('change', () => {
        getGradingFilterValues();
        getResults();
    });

    document.getElementById('grading-hrd').addEventListener('change', () => {
        getGradingFilterValues();
        getResults();
    });
}

function bindEventsShapes() {
    //Let's check if the wizard started from a setting, if so we need to check the shape that is set in the LocalStorage wizardInfo.setting_selected_shape property
    
    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
    let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
    
    if(wizardStart == 'StartWithSetting'){
        if(wizardInfo.setting_selected_shape != null){
            document.getElementById('shape-'+wizardInfo.setting_selected_shape.toLowerCase()).checked = true;
    
        }
    }
   


    document.getElementById('shape-round').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-oval').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-heart').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-radiant').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-cushion').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-emerald').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-pear').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-princess').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-marquise').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });

    document.getElementById('shape-asscher').addEventListener('change', () => {
        getShapeFilterValues();
        getResults();
    });
}

function bindEventsTypes() {    
    document.getElementsByName('filter-types').forEach((input) => {
        input.addEventListener('change', () => {
            getTypeFilterValue();
            getResults();
        });
    });
}

function bindBtnMoreFilters() {
    document.getElementById('btn-morefilters').addEventListener('click', () => {

        let morefilter_section = document.getElementById('more-filters');

        if (!morefilter_section.classList.contains('hidden')) {
            morefilter_section.classList.add('hidden');
            document.getElementById('label-btnmorefilters').innerHTML = 'SEE MORE FILTERS';
        }
        else {
            morefilter_section.classList.remove('hidden');
            document.getElementById('label-btnmorefilters').innerHTML = 'SEE LESS FILTERS';
        }

        if (screen.width <= 375) {

            let first_filters_sections = document.getElementById('first-filters-section');

            document.getElementById('arrow-btnmorefilters').innerHTML = '';

            if (!first_filters_sections.classList.contains('hidden')) {
                first_filters_sections.classList.add('hidden');
            }
            else {
                first_filters_sections.classList.remove('hidden');
            }
        }
        else {
            if (!morefilter_section.classList.contains('hidden')) {
                document.getElementById('arrow-btnmorefilters').innerHTML = `<svg width="13" height="13" fill="#FFF" class="bi bi-caret-fill bi-caret-up-fill" viewBox="0 0 16 16">
                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
            </svg>`;
            }
            else {
                document.getElementById('arrow-btnmorefilters').innerHTML = `<svg width="13" height="13" fill="#FFF" class="bi bi-caret-fill bi-caret-down-fill" viewBox="0 0 16 16">
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
            </svg>`;
            }
        }
    });
}

function bindResetBtn() {
    document.getElementById('btn-reset-filters').addEventListener('click', () => {
        resetFilters();
    });

    document.getElementById('btn-reset-filters-2').addEventListener('click', () => {
        resetFilters();
    });
}

function bindEventsHeartsAndArrows() {
    document.getElementById('heartarrow').addEventListener('change', () => {
        getHeartsAndArrowFilterValues();
        getResults();
    });
}

function bindEventsRealView() {
    document.getElementById('realview').addEventListener('change', () => {
        getRealViewFilterValues();
        getResults();
    });
}

function bindEventsQuickShip() {
    document.getElementById('quickship').addEventListener('change', () => {
        getQuickShipFilterValues();
        getResults();
    });
}

function bindSelectsCloseEvents() {
    document.addEventListener("click", closeAllSelectDelivery);
    document.addEventListener("click", closeAllSelectSort);
    document.addEventListener("click", closeAllSelectView);
}

function bindEventsWishListView(){
  document.getElementById("btn-container-wishList").addEventListener('click', event => { 
    typeView='wishList';
    createCardGridWishList();     
  });  
}

function bindEventsAllGemstoneView(){
  document.getElementById("btn-group-grilla").addEventListener('click', event => { 
      typeView='allDiamonds';
     // getResults();
  $('.compare_data #list-view').addClass('hidden');
    $('.result_container div#results').removeClass('hidden');
  });  
}

function bindEvents() {
    bindEventsPrice();
    bindEventsCarat();
    bindEventsClarity();
    bindEventsColor();
    bindEventsCut();
    bindEventsRatio();
    bindEventsFluor();
    bindEventsPolish();
    bindEventsSymmetry();
    bindEventsDepth();
    bindEventsTable();
    bindEventsGrading();
    bindEventsShapes();
    bindEventsTypes();
    bindEventsHeartsAndArrows();
    bindEventsRealView();
    bindEventsQuickShip();
    bindBtnMoreFilters();
    bindResetBtn();
    bindSelectsCloseEvents();
    bindEventsWishListView();
    bindEventsAllGemstoneView();
}

//#endregion

//#region Get Values Filters

function getPriceFilterValues() {
    let priceFilter = priceSlider.noUiSlider.get();
    filters.price_min = parseInt(priceFilter[0]).toString();
    filters.price_max = parseInt(priceFilter[1]).toString();
  let min_price = currentCurrencySymbol+''+toNumberFormat(priceFilter[0] * currentRate);
      let max_price = currentCurrencySymbol+''+toNumberFormat(priceFilter[1] * currentRate);
    if(parseInt(priceFilter[0]) > parseInt(initFiltValues.price[0]) || parseInt(priceFilter[1]) < parseInt(initFiltValues.price[1]))
    {
     if($('#bar-filter[data-name="Price"]').length < 1){
          bar_filter('Price',min_price,max_price);
      }else{
    $('#bar-filter[data-name="Price"] .main_fliter_text').text(`${min_price} - ${max_price} Price`)
     }
     }else{
      $('#bar-filter[data-name="Price"]').remove();
    } 
}

function getCaratFilterValues() {
    let caratFillter = caratSlider.noUiSlider.get();
    filters.carat_min = caratFillter[0].toString();
    filters.carat_max = caratFillter[1].toString();
  if(caratFillter[0] > initFiltValues.carat[0] || caratFillter[1] < initFiltValues.carat[1])
    {
       if($('#bar-filter[data-name="Carat"]').length < 1){
          bar_filter('Carat',caratFillter[0].toString(),caratFillter[1].toString());
      }else{
    $('#bar-filter[data-name="Carat"] .main_fliter_text').text(`${caratFillter[0].toString()} - ${caratFillter[1].toString()} Carat`)
     }
     }else{
      $('#bar-filter[data-name="Carat"]').remove();
    } 
  
}

function getColorFilterValues() {
    let colorFilter = colorSlider.noUiSlider.get();
    let colorValues = ['J', 'I', 'H', 'G', 'F', 'E', 'D'];
 
    filters.color_to = colorValues[parseInt(colorFilter[0])>0?parseInt(colorFilter[0]):0];
    filters.color_from = colorValues[parseInt(colorFilter[1])>0?parseInt(colorFilter[1])-1:0];

  if(colorValues[parseInt(colorFilter[1])>0?parseInt(colorFilter[1])-1:0] != 'D' || colorValues[parseInt(colorFilter[0])>0?parseInt(colorFilter[0]):0] != 'J')
  {
   if($('#bar-filter[data-name="Color"]').length < 1){
      bar_filter('Color',colorValues[parseInt(colorFilter[0])>0?parseInt(colorFilter[0]):0],colorValues[parseInt(colorFilter[1])>0?parseInt(colorFilter[1])-1:0]);
  }else{
    $('#bar-filter[data-name="Color"] .main_fliter_text').text(`${colorValues[parseInt(colorFilter[0])>0?parseInt(colorFilter[0]):0]} - ${colorValues[parseInt(colorFilter[1])>0?parseInt(colorFilter[1])-1:0]} Color`)
     }
  }else{
    $('#bar-filter[data-name="Color"]').remove();
  }
}

function getClarityFilterValues() {
    let clarityFilter = claritySlider.noUiSlider.get();
    let clarityValues = ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF'];
    filters.clarity_to = clarityValues[parseInt(clarityFilter[1])>0?parseInt(clarityFilter[1])-1:0];
    filters.clarity_from = clarityValues[parseInt(clarityFilter[0])>0?parseInt(clarityFilter[0]):0];
  if(clarityValues[parseInt(clarityFilter[1])>0?parseInt(clarityFilter[1])-1:0] != 'IF' || clarityValues[parseInt(clarityFilter[0])>0?parseInt(clarityFilter[0]):0] != 'SI2')
  {
   if($('#bar-filter[data-name="Clarity"]').length < 1){
      bar_filter('Clarity',clarityValues[parseInt(clarityFilter[0])>0?parseInt(clarityFilter[0]):0], clarityValues[parseInt(clarityFilter[1])>0?parseInt(clarityFilter[1])-1:0]);
  }else{
     $('#bar-filter[data-name="Clarity"] .main_fliter_text').text(`${clarityValues[parseInt(clarityFilter[0])>0?parseInt(clarityFilter[0]):0]} - ${clarityValues[parseInt(clarityFilter[1])>0?parseInt(clarityFilter[1])-1:0]} Clarity`)
  }
  }else{
    $('#bar-filter[data-name="Clarity"]').remove();
  }
}

function getCutFilterValues() {
    let cutFilter = cutSlider.noUiSlider.get();
    let cutValues = ['Fair', 'Good', 'Very Good', 'Excellent','Ideal'];
   
    filters.cut_to = cutValues[parseInt(cutFilter[1])>0?parseInt(cutFilter[1])-1:0];
    filters.cut_from = cutValues[parseInt(cutFilter[0])>0?parseInt(cutFilter[0]):0];
  if(cutValues[parseInt(cutFilter[0])>0?parseInt(cutFilter[0]):0] != 'Fair' || cutValues[parseInt(cutFilter[1])>0?parseInt(cutFilter[1])-1:0] != 'Ideal')
   {
   if($('#bar-filter[data-name="Cut"]').length < 1){
      bar_filter('Cut',cutValues[parseInt(cutFilter[0])>0?parseInt(cutFilter[0]):0],cutValues[parseInt(cutFilter[1])>0?parseInt(cutFilter[1])-1:0]);
  }
   else{
     $('#bar-filter[data-name="Cut"] .main_fliter_text').text(`${cutValues[parseInt(cutFilter[1])>0?parseInt(cutFilter[1])-1:0]} - ${cutValues[parseInt(cutFilter[0])>0?parseInt(cutFilter[0]):0]} Cut`)
   }  
  }else{
    $('#bar-filter[data-name="Cut"]').remove();
  }
}

function getGradingFilterValues() {

    filters.labs = [];
    let optionGIA = document.getElementById('grading-gia');
    let optionIGI = document.getElementById('grading-igi');
    let optionHRD = document.getElementById('grading-hrd');

    if (optionGIA.checked === true) {
     filters.labs.push(optionGIA.value);
     if($('#bar-filter[data-name="GIA"]').length < 1){
      bar_filter('GIA');
       }
    }else{
      $('#bar-filter[data-name="GIA"]').remove();
    }

    if (optionIGI.checked === true) {
      filters.labs.push(optionIGI.value);
      if($('#bar-filter[data-name="IGI"]').length < 1){
        bar_filter('IGI');
        }
    }else{
       $('#bar-filter[data-name="IGI"]').remove();
    }

    if (optionHRD.checked === true) {
        filters.labs.push(optionHRD.value);
      if($('#bar-filter[data-name="HRD"]').length < 1){
        bar_filter('HRD');
      }
    }else{
      $('#bar-filter[data-name="HRD"]').remove();
    }

}

function getPolishFilterValues() {
    let polishFilter = polishSlider.noUiSlider.get();
    let polishValues = ['Good', 'Very Good', 'Excellent'];
    filters.polish_to = polishValues[parseInt(polishFilter[1])>0?parseInt(polishFilter[1])-1:0];
    filters.polish_from = polishValues[parseInt(polishFilter[0])>0?parseInt(polishFilter[0]):0];
if(polishValues[parseInt(polishFilter[1])>0?parseInt(polishFilter[1])-1:0] != 'Excellent' || polishValues[parseInt(polishFilter[0])>0?parseInt(polishFilter[0]):0] != 'Good')
   {
   if($('#bar-filter[data-name="Polish"]').length < 1){
      bar_filter('Polish',polishValues[parseInt(polishFilter[0])>0?parseInt(polishFilter[0]):0],polishValues[parseInt(polishFilter[1])>0?parseInt(polishFilter[1])-1:0]);
  }else{
     $('#bar-filter[data-name="Polish"] .main_fliter_text').text(`${polishValues[parseInt(polishFilter[0])>0?parseInt(polishFilter[0]):0]} - ${polishValues[parseInt(polishFilter[1])>0?parseInt(polishFilter[1])-1:0]} Polish`)
   }  
  }else{
    $('#bar-filter[data-name="Polish"]').remove();
  }
}

function getFluorFilterValues() {
    let fluorFilter = fluorSlider.noUiSlider.get();
    let fluorValues = ['Very Slight', 'Slight',  'None'];
    let from = parseInt(fluorFilter[0])>0?parseInt(fluorFilter[0]):0;
    let to = parseInt(fluorFilter[1])>0?parseInt(fluorFilter[1])-1:0;
    console.log(fluorValues[parseInt(fluorFilter[0])>0?parseInt(fluorFilter[0]):0]+'='+fluorValues[parseInt(fluorFilter[1])>0?parseInt(fluorFilter[1])-1:0])

    console.log(fluorFilter[0],'eeee');
    console.log(parseInt(fluorFilter[1]));
    if( parseInt(fluorFilter[0]) > 0 || parseInt(fluorFilter[1]) < 3)
    {
     if($('#bar-filter[data-name="Fluor"]').length < 1){
        bar_filter('Fluor',fluorValues[parseInt(fluorFilter[0])>0?parseInt(fluorFilter[0]):0],fluorValues[parseInt(fluorFilter[1])>0?parseInt(fluorFilter[1])-1:0]);
    }else{
     $('#bar-filter[data-name="Fluor"] .main_fliter_text').text(`${fluorValues[parseInt(fluorFilter[0])>0?parseInt(fluorFilter[0]):0]} - ${fluorValues[parseInt(fluorFilter[1])>0?parseInt(fluorFilter[1])-1:0]} Fluor`)
   } 
    }else{
      $('#bar-filter[data-name="Fluor"]').remove();
    }
    filters.fluorescence_intensities = [];
    if(parseInt(fluorFilter[0]) == parseInt(fluorFilter[1])){
        filters.fluorescence_intensities.push(fluorValues[parseInt(to)]);
    }
    else{
        for (let i = from; i <= to; i++) {
            filters.fluorescence_intensities.push(fluorValues[i]);
        }
    }
}

function getSymmetryFilterValues() {
    let symmetryFilter = symmetrySlider.noUiSlider.get();
    let symmetryValues = ['Good', 'Very Good', 'Excellent'];
    filters.symmetry_to = symmetryValues[parseInt(symmetryFilter[1])>0?parseInt(symmetryFilter[1])-1:0];
    filters.symmetry_from = symmetryValues[parseInt(symmetryFilter[0])>0?parseInt(symmetryFilter[0]):0];
   if(symmetryValues[parseInt(symmetryFilter[1])>0?parseInt(symmetryFilter[1])-1:0] != 'Excellent' || symmetryValues[parseInt(symmetryFilter[0])>0?parseInt(symmetryFilter[0]):0] != 'Good')
    {
     if($('#bar-filter[data-name="Symmetry"]').length < 1){
        bar_filter('Symmetry',symmetryValues[parseInt(symmetryFilter[0])>0?parseInt(symmetryFilter[0]):0],symmetryValues[parseInt(symmetryFilter[1])>0?parseInt(symmetryFilter[1])-1:0]);
    }else{
     $('#bar-filter[data-name="Symmetry"] .main_fliter_text').text(`${symmetryValues[parseInt(symmetryFilter[0])>0?parseInt(symmetryFilter[0]):0]} - ${symmetryValues[parseInt(symmetryFilter[1])>0?parseInt(symmetryFilter[1])-1:0]} Symmetry`)
   } 
  }else{
      $('#bar-filter[data-name="Symmetry"]').remove();
    }
}

function getRatioFilterValues() {
    let ratioFillter = ratioSlider.noUiSlider.get();
    filters.ratio_from = ratioFillter[0].toString();
    filters.ratio_to = ratioFillter[1].toString();
  if( ratioFillter[0] > initFiltValues.ratio[0] || ratioFillter[1] < initFiltValues.ratio[1])
  {
     if($('#bar-filter[data-name="Ratio"]').length < 1){
        bar_filter('Ratio',ratioFillter[0].toString(),ratioFillter[1].toString());
    }else{
     $('#bar-filter[data-name="Ratio"] .main_fliter_text').text(`${ratioFillter[0].toString()} - ${ratioFillter[1].toString()} Ratio`)
   } 
   }else{
      $('#bar-filter[data-name="Ratio"]').remove();
    }
 }

function getDepthFilterValues() {
    let depthFillter = depthSlider.noUiSlider.get();
    filters.depth_percent_from = depthFillter[0].toString();
    filters.depth_percent_to = depthFillter[1].toString();
   if( depthFillter[0] > initFiltValues.depth[0] || depthFillter[1] < initFiltValues.depth[1])
    {
     if($('#bar-filter[data-name="Depth"]').length < 1){
        bar_filter('Depth',depthFillter[0].toString(),depthFillter[1].toString());
    }else{
     $('#bar-filter[data-name="Depth"] .main_fliter_text').text(`${depthFillter[0].toString()} - ${depthFillter[1].toString()} Depth`)
   } 
   }else{
      $('#bar-filter[data-name="Depth"]').remove();
    }
   
}

function getTableFilterValues() {
    let tableFillter = tableSlider.noUiSlider.get();
    filters.table_percent_from = tableFillter[0].toString();
    filters.table_percent_to = tableFillter[1].toString();
  if( tableFillter[0] > initFiltValues.table[0] || tableFillter[1] < initFiltValues.table[1])
    {
     if($('#bar-filter[data-name="Table"]').length < 1){
        bar_filter('Table',tableFillter[0].toString(),tableFillter[1].toString());
    }else{
     $('#bar-filter[data-name="Table"] .main_fliter_text').text(`${tableFillter[0].toString()} - ${tableFillter[1].toString()} Table`)
   } 
   }else{
      $('#bar-filter[data-name="Table"]').remove();
    }
  
 
}

function getTypeFilterValue() {    
    let types = document.getElementsByName('filter-types');    
    for (let i = 0, length = types.length; i < length; i++) {
        if (types[i].checked) {
            filters.search_type = types[i].value;
        }
    }  
}

function getShapeFilterValues() {

    filters.shapes = [];

    let optionRound = document.getElementById('shape-round');
    let optionOval = document.getElementById('shape-oval');
    let optionHeart = document.getElementById('shape-heart');
    let optionRadiant = document.getElementById('shape-radiant');
    let optionCushion = document.getElementById('shape-cushion');
    let optionEmerald = document.getElementById('shape-emerald');
    let optionPear = document.getElementById('shape-pear');
    let optionPrincess = document.getElementById('shape-princess');
    let optionMarquise = document.getElementById('shape-marquise');
    let optionAsscher = document.getElementById('shape-asscher');

    if (optionRound.checked === true) {
        filters.shapes.push(optionRound.value);
      if($('#bar-filter[data-name="Round"]').length < 1){
        bar_filter('Round');
    }
    }else{
       $('#bar-filter[data-name="Round"]').remove();
    }

    if (optionOval.checked === true) {
        filters.shapes.push(optionOval.value);
    if($('#bar-filter[data-name="Oval"]').length < 1){
        bar_filter('Oval');
    }
    }else{
       $('#bar-filter[data-name="Oval"]').remove();
    }

    if (optionHeart.checked === true) {
    filters.shapes.push(optionHeart.value);
      if($('#bar-filter[data-name="Heart"]').length < 1){
        bar_filter('Heart');
    }
    }else{
       $('#bar-filter[data-name="Heart"]').remove();
    }

    if (optionRadiant.checked === true) {
        filters.shapes.push(optionRadiant.value);
      if($('#bar-filter[data-name="Radiant"]').length < 1){
        bar_filter('Radiant');
      }
    }else{
         $('#bar-filter[data-name="Radiant"]').remove();
      }

    if (optionCushion.checked === true) {
        filters.shapes.push(optionCushion.value);
       if($('#bar-filter[data-name="Cushion"]').length < 1){
        bar_filter('Cushion');
      }
    }else{
         $('#bar-filter[data-name="Cushion"]').remove();
      }

    if (optionEmerald.checked === true) {
        filters.shapes.push(optionEmerald.value);
      if($('#bar-filter[data-name="Emerald"]').length < 1){
        bar_filter('Emerald');
      }
    }else{
         $('#bar-filter[data-name="Emerald"]').remove();
      }

    if (optionPear.checked === true) {
        filters.shapes.push(optionPear.value);
       if($('#bar-filter[data-name="Pear"]').length < 1){
        bar_filter('Pear');
      }
    }else{
         $('#bar-filter[data-name="Pear"]').remove();
      }

    if (optionPrincess.checked === true) {
        filters.shapes.push(optionPrincess.value);
      if($('#bar-filter[data-name="Princess"]').length < 1){
        bar_filter('Princess');
      }
    }else{
         $('#bar-filter[data-name="Princess"]').remove();
      }

    if (optionMarquise.checked === true) {
        filters.shapes.push(optionMarquise.value);
          if($('#bar-filter[data-name="Marquise"]').length < 1){
          bar_filter('Marquise');
          }
    }else{
             $('#bar-filter[data-name="Marquise"]').remove();
          }

    if (optionAsscher.checked === true) {
        filters.shapes.push(optionAsscher.value);
        if($('#bar-filter[data-name="Asscher"]').length < 1){
          bar_filter('Asscher');
          }
    }else{
             $('#bar-filter[data-name="Asscher"]').remove();
        }
}

function getHeartsAndArrowFilterValues() {
    let heartsAndArrows = document.getElementById('heartarrow');
    filters.heartsandarrow = (heartsAndArrows.checked === true ? `"Hearts and Arrows"` : '') ;
   if (heartsAndArrows.checked === true) {
      if($('#bar-filter[data-name="Heart & Arrow"]').length < 1){
          bar_filter('Heart & Arrow');
          }
    }else{
             $('#bar-filter[data-name="Heart & Arrow"]').remove();
        }
   }


function getRealViewFilterValues() {
    let realViewFilter = document.getElementById('realview');
    filters.realview = (realViewFilter.checked === true);
  if (realViewFilter.checked === true) {
      if($('#bar-filter[data-name="Real View"]').length < 1){
          bar_filter('Real View');
          }
    }else{
             $('#bar-filter[data-name="Real View"]').remove();
        }
}

function getQuickShipFilterValues() {
    let quickShipFilter = document.getElementById('quickship');
    filters.quickship = (quickShipFilter.checked === true ? `["New York", "Los Angeles"]` : '');
  if (quickShipFilter.checked === true) {
      if($('#bar-filter[data-name="Quick Ship"]').length < 1){
          bar_filter('Quick Ship');
          }
    }else{
             $('#bar-filter[data-name="Quick Ship"]').remove();
  }
}

function getDeliveryFilterValues() {
    
    let deliverySelected;
    let deliverySelect = document.getElementsByClassName('select-items')[0];
    let hasSelected = deliverySelect.querySelector('.same-as-selected');
    let selected_filter = $('.same-as-selected').text();
  if(selected_filter != ''){
     if($('#bar-filter[data-name="Delivery"]').length < 1){
        bar_filter('Delivery',selected_filter);
    }else{
       $('#bar-filter[data-name="Delivery"] .main_fliter_text').text(selected_filter+' Delivery');
    }
  }
    if (hasSelected != undefined) {
        
        let selectDelivery = document.getElementById('selectDelivery');
        deliverySelected = parseInt(selectDelivery.options[selectDelivery.selectedIndex].value);
    }
    else {
        deliverySelected = 0;
    }

    filters.delivery_city = '';
    filters.delivery_country = '';

    if (deliverySelected > 0) {

        if (deliverySelected >= 4 && deliverySelected <= 10) {
            filters.delivery_country = `"USA"`;
        }

        if (deliverySelected >= 1 && deliverySelected <= 3) {
            filters.delivery_country = `"USA"`;
            filters.delivery_city = `["New York"]`;
        }
    }    
}

//#endregion

//#region Reset Methods

function resetGradingFilter() {
    document.getElementById('grading-gia').checked = false;
    document.getElementById('grading-igi').checked = false;
    document.getElementById('grading-hrd').checked = false;

}

function resetShapeFilter() {
    document.getElementById('shape-round').checked = false;
    document.getElementById('shape-oval').checked = false;
    document.getElementById('shape-heart').checked = false;
    document.getElementById('shape-radiant').checked = false;
    document.getElementById('shape-cushion').checked = false;
    document.getElementById('shape-emerald').checked = false;
    document.getElementById('shape-pear').checked = false;
    document.getElementById('shape-princess').checked = false;
    document.getElementById('shape-marquise').checked = false;
    document.getElementById('shape-asscher').checked = false;
}

function resetRealViewFilter() {
    document.getElementById('realview').checked = false;
}

function resetQuichShipFilter() {
    document.getElementById('quickship').checked = false;
}

function resetHeartsAndArrowsFilter() {
    document.getElementById('heartarrow').checked = false;
}

function resetDeliveryFilter() {
    
    let deliverySelect = document.getElementsByClassName('select-items select-hide')[0];

    deliverySelect.childNodes.forEach(item => {item.classList.remove('same-as-selected')});

    let visualSelected = document.getElementsByClassName('select-selected')[0];
    visualSelected.innerHTML = 'On or Before';
}

function resetFilters() {
    priceSlider.noUiSlider.set(initFiltValues.price);
    caratSlider.noUiSlider.set(initFiltValues.carat);
    colorSlider.noUiSlider.set(initFiltValues.color);
    claritySlider.noUiSlider.set(initFiltValues.clarity);
    cutSlider.noUiSlider.set(initFiltValues.cut);
    ratioSlider.noUiSlider.set(initFiltValues.ratio);
    polishSlider.noUiSlider.set(initFiltValues.polish);
    fluorSlider.noUiSlider.set(initFiltValues.fluor);
    symmetrySlider.noUiSlider.set(initFiltValues.symmetry);
    depthSlider.noUiSlider.set(initFiltValues.depth);
    tableSlider.noUiSlider.set(initFiltValues.table);

    //resetGradingFilter();
    resetShapeFilter();
    resetRealViewFilter();
    resetQuichShipFilter();
    resetHeartsAndArrowsFilter();
    resetDeliveryFilter();
    
    functionGetAllFiltersValues();
    getResults();
    bar_filter('remove');
}

//#endregion

//#region Grid View Methods

var wishListOnlyDiamondArray;

async function wishListOnlyDiamond(){  
  let wishListOnlyDiamondCount=[];
  wishListOnlyDiamondArray=[];
  let internalTimer = window.sessionStorage.getItem('wishlistTimer');
  if(internalTimer == null){
    internalTimer = 0;
    internalTimer++;
    window.localStorage.setItem('wishlistTimer', internalTimer);
  }
  else{
      if(internalTimer>2){
          //More than 2 seconds have passed, return an empty array
          wishlistOnlyDiamondArray = [];
     }
      return true;
    }
  if(window._swat){
    window.localStorage.setItem('wishlistTimer', '0');
    window._swat.fetch( function(r) {
        r.forEach(product=>{         
          if (product.hasOwnProperty("sku") && product.sku != null) {
            wishListOnlyDiamondCount.push(product);
          }          
        });    
       document.getElementById('btn-wishList').innerHTML="("+wishListOnlyDiamondCount.length+")"; 
       
       wishListOnlyDiamondCount.forEach(producto=>{
         let skuNumber = parseInt(producto.sku);
         let url = window.API_URL + `diamonds/${skuNumber}`;               
         fetch(url, {
           method: 'GET',        
           headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
         }).then(res => res.json())
             .then(async diamond => {  
              
               wishListOnlyDiamondArray.push(diamond);             
             }).catch(error => console.error('Error:', error)); 
                 
        });  
     });  
  }
  else {
    setTimeout(function(){ wishListOnlyDiamond(); }, 1000);
  }
  
}

async function createProductObject(diamond_id){    
    let url = window.API_URL +`diamonds/${diamond_id}`;   
    let producto;
    var product = await fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json','X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM'},            
    }).then(res => res.json())
     .then(async product => {    
     producto = product;
   }).catch(error => console.error('Error:', error));   

   return producto;
}

async function existProduct(diamond_id){ 
  let url = window.API_URL +`diamonds/${diamond_id}`; 
  let diamond;
  var result = await fetch(url, {
        method: 'GET',
        headers: {'Content-Type': 'application/json','X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM'},            
    }).then(res => res.json())
     .then(async result => {          
       diamond = result;
   }).catch(error => console.error('Error:', error));    
    return diamond;

}

function existInWishList(array, shopify_product_id ){
  let exist = false;
  shopify_product_id = parseInt(shopify_product_id); 
  array.forEach(product=>{
    if (product.empi == shopify_product_id) {
      exist = true;
    }
  });  
  return exist;
}

async function addProductWishList(product){
  let productDto = {
    'empi':product.variants[0].product_id,
    'epi':product.variants[0].id
    }; 
  window._swat.addToWishList(productDto,function(e) {     
    wishListOnlyDiamond();
  });    
}

async function addProductDiamondWishList(product){ 
    product.empi= parseInt(product.empi); 
    product.epi= parseInt(product.epi);  
  window._swat.addToWishList(product,function(e) {       
    wishListOnlyDiamond();
  });     
}

async function removeProductWishList(product){
  product.empi= parseInt(product.empi); 
  product.epi= parseInt(product.epi); 
  window._swat.removeFromWishList(product,function(j) {    
    
      if (typeView ==='wishList') {
        createCardGridWishList(); 
        wishListOnlyDiamond();
        
      } else {
         wishListOnlyDiamond();        
      }
    });
  
 

  
    
}

async function SaveWishList(diamond){
  window._swat.fetch( async function(r) {   
    wishListArray=r;      
    let diamondProduct= await existProduct(diamond.diamond_id); //Traigo diamante con campo IdShopify      

    if (diamondProduct.shopify_product_id == null) {//si IdShopify  es null no existe el producto
           
      let newProduct = await createProductObject(diamond.diamond_id);  // creo un producto      
      await addProductWishList(newProduct); // guardo en WishList  
      
      //agrego corazon negro
      document.getElementById("btn-"+diamond.diamond_id).innerHTML=``;
      document.getElementById("btn-"+diamond.diamond_id).innerHTML=`<svg id="btn-${diamond.diamond_id}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart-fill icon-heart btn-heart" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
      </svg>`;   
    
    } else {  
      
      //si existe el producto tengo que comprobar si esta en la wishList;   
      let productInWishList = existInWishList(wishListArray, diamondProduct.shopify_product_id ); 
      let productDto = { //Armo el producto para reamover o para agregar a WishList
      'empi':diamondProduct.shopify_product_id,
      'epi': diamondProduct.variant_id
      }; 
      
      
      if (productInWishList) {//remove wishList           
        
          await removeProductWishList(productDto); 
          //agrego corazon blanco
          document.getElementById("btn-"+diamond.diamond_id).innerHTML=``;
          document.getElementById("btn-"+diamond.diamond_id).innerHTML=`<svg id="btn-${diamond.diamond_id}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart icon-heart btn-heart" viewBox="0 0 16 16">
          <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"/>
          </svg>`; 
        
      } else {//addWishList               
       
        await addProductDiamondWishList(productDto);   
        //agrego corazon negro
        document.getElementById("btn-"+diamond.diamond_id).innerHTML=``;
        document.getElementById("btn-"+diamond.diamond_id).innerHTML=`<svg id="btn-${diamond.diamond_id}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart-fill icon-heart btn-heart" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
        </svg>`;     
      }
    }
    
  });

}

function moreDetailsCardGrid(id) {
    let screenWidth = screen.width;
    if (screenWidth > 375) {
        let card = document.getElementById(id);
        card.style.transform = 'rotateY(180deg)';
    }

    if (screenWidth <= 375) {
        let app = document.getElementById(id);
        app.getElementsByClassName("other-detail-min")[0].style.display = 'block';
    }
}

function backDetailsCardGrid(id) {
    let screenWidth = screen.width;
    if (screenWidth > 375) {
        let card = document.getElementById(id);
        card.style.transform = 'rotateY(360deg)';
    }

    if (screenWidth <= 375) {
        let app = document.getElementById(id);
        app.getElementsByClassName("other-detail-min")[0].style.display = 'none';
    }

}

function createCardGrid(element) {   
  
    let diamond_image='';
    // If element.shape.toLowerCase() contains cushion just keep cushion and remove extra words
    lowerCaseShape = element.shape.toLowerCase();
    if(lowerCaseShape.includes('cushion')){
        lowerCaseShape = 'cushion';
    }
    

    switch (lowerCaseShape) {
        case 'round':
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-round.png?v=1681486955'                      
            break;
        case 'oval':
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-oval.png?v=1681486978'
            break;
        case 'heart':
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-heart.png?v=1681486978'
            break;
        case 'radiant':
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-radiant.png?v=1681486955'
            break;
        case 'cushion':
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-cushion.png?v=1681486978'
            break;
        case 'emerald':
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-emerald.png?v=1681486979'
            break;
        case 'pear':
            diamond_image = 'https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-pear.png?v=1681486486'
            break;
        case 'princess':
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-princess.png?v=1681486955'
            break;
        case 'marquise':
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-marquise.png?v=1681486978'
            break;
        case 'asscher':
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-asscher.png?v=1681486978'
            break;   
        case 'trapezoid':
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-baguette.png?v=1681486978'
            break;             
    
        default:
            diamond_image='https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-round.png?v=1681486955'                      
            break;
    }   

    let price = toCurrencyFormat(element.total_sales_price);
    let carat = toNumberFormat(element.size); 
    let depth = toNumberFormat(element.depth);
    let table = toNumberFormat(element.table);  

    let card = document.createElement('div');
    card.classList.add('col', 'aling-items-center', 'p-0', 'pb-4', 'col-card', 'mb-3');

    let isWishList = false;
    wishlistOnlyDiamondArray = wishListOnlyDiamondArray || [];
    if(wishListOnlyDiamondArray && wishlistOnlyDiamondArray.length>0){
        wishListOnlyDiamondArray.forEach(diamond => {
            if (element.diamond_id == diamond.Diamond_ID) {
              isWishList=true;        
            }
          });
    }
    
    if (isWishList) {
    card.innerHTML = `
   
      <svg id="btn-${element.diamond_id}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart-fill icon-heart btn-heart" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
      </svg>
 
    <div class="card" id="${element.diamond_id}">
        <div class="card-front">
            <div class="d-flex justify-content-center m-0">     
                <img src="${diamond_image}" class="card-img-top diamondcard-img"  loading="lazy">  
                <div class="other-detail-min">
                    <svg  xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" class="bi bi-x icon-close" viewBox="4 4 8 8">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                    <div>                       
                        <h3>Depth - ${depth}%</h3>
                        <h3>Table - ${table}%</h3>  
                        <h3>Fluorescence - ${element.fluor_intensity}</h3>
                        <h3>Polish - ${element.polish}</h3>
                        <h3>Symmetry - ${element.symmetry}</h3>
                    </div>
                </div>
            </div>
            <div class="card-body mt-3">
                <h3 class="card-text card-title">${carat} - Carat ${element.shape}</h3>
                <h3 class="card-text card-title">${element.polish} ${element.color} ${element.clarity}</h3>
            </div>
            <div class="card-body d-flex justify-content-between align-items-center mt-4 pt-4">
                <h4 class="card-text card-price">${price}</h4>
                <a onmouseover="moreDetailsCardGrid(${element.diamond_id})" onmouseout="backDetailsCardGrid(${element.diamond_id})">
                    <h4 class="card-text card-details">Other Details</h4>
                </a>
            </div>
        </div>                         
        
        <div class="card-back">                                              
            <div class="card-body body-back">
                <div class="container-text-back">
                    <h3 class="card-text card-title">Depth - ${depth}%</h3>
                    <h3 class="card-text card-title">Table - ${table}%</h3>  
                    <h3 class="card-text card-title">Fluorescence - ${element.fluor_intensity}</h3>
                    <h3 class="card-text card-title">Polish - ${element.polish}</h3>   
                    <h3 class="card-text card-title">Symmetry - ${element.symmetry}</h3>
                                             
                </div>
            </div>  
            <div class="card-body d-flex justify-content-between align-items-center mt-4 pt-4">
                <h4 class="card-text card-price">${price}</h4>
                <a onmouseover="moreDetailsCardGrid(${element.diamond_id})" onmouseout="backDetailsCardGrid(${element.diamond_id})" 
                class=""><h4 class="card-text card-details">Other Details</h4></a>
            </div>                         
        </div>
    </div>`;
      
    } else {
    let dimensionsStr  = '';
    if(element.measurements){
        dimensionsStr = `<h3 class="card-text card-title">Dimensions - ${element.measurements}</h3>`;
    }
     card.innerHTML = `
  
      <svg id="btn-${element.diamond_id}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-heart icon-heart btn-heart" viewBox="0 0 16 16">
        <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"/>
      </svg>      

    <div class="card" id="${element.diamond_id}">
        <div class="card-front">
            <div class="d-flex justify-content-center m-0">     
                <img src="${diamond_image}" class="card-img-top diamondcard-img"  loading="lazy">  
                <div class="other-detail-min">
                    <svg  xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" class="bi bi-x icon-close" viewBox="4 4 8 8">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                    <div>                       
                        <h3>Depth - ${depth}%</h3>
                        <h3>Table - ${table}%</h3>  
                        <h3>Fluorescence - ${element.fluor_intensity}</h3>
                        <h3>Polish - ${element.polish}</h3>
                        <h3>Symmetry - ${element.symmetry}</h3>
                        
                    </div>
                </div>
            </div>
            <div class="card-body mt-3">
                <h3 class="card-text card-title">${carat}Ct. - ${element.shape}</h3>
                <h3 class="card-text card-title">${element.polish} ${element.color} ${element.clarity}</h3>
            </div>
            <div class="card-body d-flex justify-content-between align-items-center mt-4 pt-4">
                <h4 class="card-text card-price">${price}</h4>
                <a onmouseover="moreDetailsCardGrid(${element.diamond_id})" onmouseout="backDetailsCardGrid(${element.diamond_id})">
                    <h4 class="card-text card-details">Other Details</h4>
                </a>
            </div>
        </div>                         
        
        <div class="card-back">                                              
            <div class="card-body body-back">
                <div class="container-text-back">
                    <h3 class="card-text card-title">Depth - ${depth}%</h3>
                    <h3 class="card-text card-title">Table - ${table}%</h3>  
                    <h3 class="card-text card-title">Fluorescence - ${element.fluor_intensity}</h3>
                    <h3 class="card-text card-title">Polish - ${element.polish}</h3>   
                    <h3 class="card-text card-title">Symmetry - ${element.symmetry}</h3>
                    <h3  class="card-text card-title">Certification - ${element.lab}</h3>
                    ${dimensionsStr}                           
                </div>
            </div>  
            <div class="card-body d-flex justify-content-between align-items-center mt-4 pt-4">
                <h4 class="card-text card-price">${price}</h4>
                <a onmouseover="moreDetailsCardGrid(${element.diamond_id})" onmouseout="backDetailsCardGrid(${element.diamond_id})" 
                class=""><h4 class="card-text card-details">Other Details</h4></a>
            </div>                         
        </div>
    </div>`;
    
    }  
  
    
    document.getElementById('grid-view').appendChild(card);
    document.getElementById(`${element.diamond_id}`).addEventListener('click', event => {    
        setLocalStorageId(element.diamond_id);
        window.location.href = window.location.origin + '/pages/diamond-detail-new?did=' + element.diamond_id;
    });

     document.getElementById("btn-"+element.diamond_id).addEventListener('click', event => { 
       this.SaveWishList(element); 
    });

     
}   

async function createCardGridWishList(){    
  
  let viewSelected = document.getElementById('selectView').options[selectView.selectedIndex].value; 
  document.getElementById('grid-view').innerHTML = '';    
  
  document.getElementById('grid-searchzone').style.display = "flex";
  let paginationZone = document.getElementById('pagination-zone');
  paginationZone.style.visibility = "hidden"; 

  document.getElementById('btn-group-grilla').getElementsByTagName('button')[0].classList.remove('add_border');  
  document.getElementById('btn-container-wishList').getElementsByTagName('button')[0].classList.add('add_border');

  setTimeout(()=>{
  document.getElementById('grid-searchzone').style.display = "none";

  wishListOnlyDiamondArray.forEach(diamond => {    
    let element={
      total_sales_price:diamond.Total_Price,
      size:diamond.Weight,
      depth: diamond.Depth_Percent,
      table:diamond.Table_Percent,
      diamond_id: diamond.Diamond_ID,
      diamond_image:'',
      fluor_intensity:diamond.Fluorescence_Intensity,
      polish:diamond.Polish,
      symmetry:diamond.Symmetry,
      shape:diamond.Shape,
      color:diamond.Color,
      clarity:diamond.Clarity      
    };
    createCardGrid(element);
  });   
    
 },2000);
  
}

function getConfigSortGrid() {

    let selectSort = document.getElementById('selectSort');
    let valor = selectSort.options[selectSort.selectedIndex].value;
    let sortby;
    let sortDirection;
    let elements

    switch (valor) {
        case "0":
            sortby = 'total_sales_price';
            sortDirection = 'ASC';
            elements = [sortby, sortDirection];
            break;
        case "1":
            sortby = 'total_sales_price';
            sortDirection = 'DESC';
            elements = [sortby, sortDirection];
            break;
        case "2":
            sortby = 'size';
            sortDirection = 'ASC';
            elements = [sortby, sortDirection];
            break;
        case "3":
            sortby = 'size';
            sortDirection = 'DESC';
            elements = [sortby, sortDirection];
            break;
        default:
            sortby = 'total_sales_price';
            sortDirection = 'ASC';
            elements = [sortby, sortDirection];
            break;
    }

    return elements;
}

function resetSortSelectGrid() {
    let sortSelect = document.getElementsByClassName('sort-select-items sort-select-hide')[0];

    sortSelect.childNodes.forEach(item => {item.classList.remove('same-as-selected-sort')});

    sortSelect.childNodes[0].setAttribute('class', 'same-as-selected-sort');

    let visualSelected = document.getElementsByClassName('sort-select-selected sort-custom-selected')[0];
    visualSelected.innerHTML = sortSelect.childNodes[0].innerHTML;
    
}

//#endregion

//#region Table View Methods



function toggleExpandedTableSection(element, show) {
    var target = document.getElementById(element.getAttribute('aria-controls'));
                 
    if (target) {
        element.setAttribute('aria-expanded', show);
      
        if (show) {
            element.querySelector('#arrow-table-detail').classList.remove('bi-chevron-down');
            element.querySelector('#arrow-table-detail').classList.add('bi-chevron-up');
            element.querySelector('#arrow-table-detail').innerHTML = `<path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>`;
        } else {
            element.querySelector('#arrow-table-detail').classList.remove('bi-chevron-up');
            element.querySelector('#arrow-table-detail').classList.add('bi-chevron-down');
            element.querySelector('#arrow-table-detail').innerHTML = `<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>`;
        }
        $(element).find('.p-table__expanding-panel').attr('aria-hidden',!show);
        //target.setAttribute('aria-hidden', !show);
    }
}

function bindExpandableTableResults(table) {

    table.addEventListener('click', function (event) {
        let target = event.target;
        if (target.hasAttribute('aria-div')) {
            target = document.getElementById(target.getAttribute('aria-div'));
        }

        if (!target.classList.contains('u-toggle')) {
            target = target.parentElement;
        }

        var isTargetOpen = target.getAttribute('aria-expanded') === 'true';

        if (target.classList.contains('u-toggle')) {
            toggleExpandedTableSection(target, !isTargetOpen);
        }
    });
}

function sortTableResults(header, table) {

    let col = [].slice.call(table.tHead.rows[0].cells).indexOf(header);
    let sort_by = getSortByTableResults(col);

    let sort_direction = header.getAttribute('aria-sort');
    sort_direction = sort_direction === 'DESC' ? 'ASC' : 'DESC';
    header.classList.add('bold-header');
    
    let headerSorts = table.querySelectorAll('[aria-sort]');
    for (var i = 0, ii = headerSorts.length; i < ii; i += 1) {
        if(headerSorts[i] != header){
            headerSorts[i].setAttribute('aria-sort', 'DESC');
            headerSorts[i].classList.remove('bold-header');
        }
        // Removing this that removes the sort direction from the header.
        //headerSorts[i].setAttribute('aria-sort', 'none');
    }

    // Set the new header sort.
    header.setAttribute('aria-sort', sort_direction);
    
    getDiamonds(1, sort_by, sort_direction);
}

function getSortByTableResults(col){

    let sort_by;

    switch (col) {
        case 1:
            sort_by = 'shape';
            break;
        case 2:
            sort_by = 'total_sales_price';
            break;
        case 3:
            sort_by = 'size';
            break;
        case 4:
            sort_by = 'cut';
            break;
        case 5:
            sort_by = 'color';
            break;
        case 6:
            sort_by = 'clarity';
            break;
      case 7:
        sort_by = 'measurements'
        break;
        
        case 8:
            sort_by = 'lab';
            break;
    }

    return sort_by;
}

function getSortConfigTableResults() {
    
    let sort_config;
    let sort_by;
    let sort_direction;
    let col;

    let table_results = document.getElementById('table-results');
    let headerSort = table_results.querySelectorAll('th[aria-sort]:not([aria-sort="none"]):not([aria-sort="DESC"])');
    let headerShortcls = table_results.querySelectorAll('th.bold-header');
    if (headerSort.length == 0 && headerShortcls.length == 0) {
        // Default sort: price
        col = 2; 
        sort_direction = 'DESC';
    }
    else {
        col = [].slice.call(table_results.tHead.rows[0].cells).indexOf(headerShortcls[0]);
        if(headerShortcls.length != 0){
        sort_direction = headerShortcls[0].getAttribute('aria-sort');
          col = [].slice.call(table_results.tHead.rows[0].cells).indexOf(headerShortcls[0]);
        }else{
          col = [].slice.call(table_results.tHead.rows[0].cells).indexOf(headerSort[0]);
          sort_direction = headerSort[0].getAttribute('aria-sort');
        }
    }

    sort_by = getSortByTableResults(col);
    console.log(sort_direction+'='+sort_by);
    sort_config = [sort_by, sort_direction];

    return sort_config;
}

function bindClickableHeaderTableResults(table, header) {
    header.addEventListener('click', function () {
        sortTableResults(header, table);
    });
}

function setupSortableTableResults(table) {
    
    var rows = table.tBodies[0].rows;
    for (var row = 0, totalRows = rows.length; row < totalRows; row += 1) {
        rows[row].setAttribute('data-index', row);
    }

    // Select sortable column headers.
    var clickableHeaders = table.querySelectorAll('th[aria-sort]');
    // Attach the click event for each header.
    for (var i = 0, ii = clickableHeaders.length; i < ii; i += 1) {
        bindClickableHeaderTableResults(table, clickableHeaders[i]);
    }
}

function configTableResults() {
    bindExpandableTableResults(document.getElementById('table-results'));
    setupSortableTableResults(document.getElementById('table-results'));
}

function resetHeadersTableResults() {
    let headerSorts = document.getElementById('table-results').querySelectorAll('[aria-sort]');
    for (var i = 0, ii = headerSorts.length; i < ii; i += 1) {

        let dir = 'DESC';
        if (i === 1) {
            dir = 'ASC'
        }

        headerSorts[i].setAttribute('aria-sort', dir);
    }
}

function getDiamondLinesImgTableResults(shape) {
    let shapesrc;

    switch (shape) {
        case "Round":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-round.png?v=1681486955";
            break;
        case "Radiant":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-radiant.png?v=1681486955";
            break;
        case "Princess":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-princess.png?v=1681486955";
            break;
        case "Pear":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-pear.png?v=1681486486";
            break;
        case "Oval":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-oval.png?v=1681486978";
            break;
        case "Marquise":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-marquise.png?v=1681486978";
            break;
        case "Heart":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-heart.png?v=1681486978";
            break;
        case "Emerald":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-emerald.png?v=1681486979";
            break;
        case "Cushion":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-cushion.png?v=1681486978";
            break;
        case "Asscher":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/diamond-lines-asscher.png?v=1660072977";
            break;
        default:
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-asscher.png?v=1681486978";
            break;
    }

    return shapesrc;
}

function createRowTableResults(element,pagination,index,rendom_no) {
    let diamond_lineshape_img;
    let diamond_image;
    let diamond_element_image;
    let diamond_delivery;
    let deliveryId; 
    let another_user_bag_tab;
    let quick_ship_tab;
    let diamond_image_url;
   if (rendom_no == index){
     if(window.location.href.indexOf('dyor-diamonds-new') > -1){
     localStorage.setItem('rendom_another_bag',element.diamond_id)
     }
    another_user_bag_tab =  `<div class="another_cart_tab one_available_tab">IN ANOTHER USER'S BAG</div>`
    }else{
     another_user_bag_tab = ''
     }
    // if (document.getElementById('realview').checked === true) {
    //     diamond_element_image = `<iframe src="${element.image_url}" scrolling="no"></iframe>`;
    // }
    // else {
      if(element.Column81.indexOf('d=') > -1 && element.Column81.indexOf('surl=') > -1){
       
      var Videourl=element.Column81;
       
        if(element.image_url !="-"){
          diamond_element_image = `<div class="main_video_container"><img class="play_btn"  loading="lazy" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img loading="lazy" class="diamond_image" src="${element.image_url}"/><iframe data-scaling="true"  seamless="seamless" data-src="${Videourl}" src=""  scrolling="no" width=420 height=420></iframe></div>`;
       } else{
         diamond_element_image = `<div class="main_video_container"><iframe data-scaling="true"  seamless="seamless" data-src="${Videourl}" src=""  scrolling="no" width=420 height=420></iframe></div>`;  
       }
      }else if(element.Column81.indexOf('.mp4') > -1){
      var Videourl=element.Column81;
          if(element.image_url !="-"){
         diamond_element_image = `<div class="main_video_container"><img class="play_btn"  loading="lazy" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img  loading="lazy" class="diamond_image" src="${element.image_url}"/><video width="320" height="320" playsinline="" poster="https://dsv7iunirnrax.cloudfront.net/first_image_new/diamond_${element.diamond_id}.jpg" autoplay loop muted data-url="${Videourl}"><source src="${Videourl}" type="video/mp4"> </video></div>`;
     
       } else{
        diamond_element_image = `<div class="main_video_container"><video width="320" height="320" playsinline="" poster="https://dsv7iunirnrax.cloudfront.net/first_image_new/diamond_${element.diamond_id}.jpg" autoplay loop muted data-url="${Videourl}"><source src="${Videourl}" type="video/mp4"> </video></div>`;
            }
      
      }else if(element.Column81 !=''){
        
        if(element.image_url !="-"){
          diamond_element_image = `<div class="main_video_container"><img class="play_btn"  loading="lazy" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img  loading="lazy" class="diamond_image" src="${element.image_url}"/><iframe data-src="${element.Column81}" src="" poster="" scrolling="no" width=420 height=420></iframe></div>`;
       } else{
          diamond_element_image = `<div class="main_video_container"><iframe data-src="${element.Column81}" src="" poster="" scrolling="no" width=420 height=420></iframe></div>`;
      }
        
      }else{  
         if (element.image_url != '') {  
         diamond_image = getDiamondImageUrl(element);
     }
    else {
      diamond_image_url =  getDiamondLinesImgTableResults(element.shape)
      diamond_image = getDiamondLinesImgTableResults(element.shape);
     }
      diamond_element_image = diamond_image;
      }
    // }

    
    //diamond_element_image = `<img src="${diamond_image}">`;    

    diamond_lineshape_img = getDiamondLinesImgTableResults(element.shape);

    deliveryId = 0;
    if (element.country != 'USA') {
        deliveryId = 11;
    }

    if (element.country === 'USA' && element.city != 'New York') {
        deliveryId = 4;
    }

    if (element.country === 'USA' && element.city === 'New York') {
        deliveryId = 1;
       quick_ship_tab=`<div class="quick_tab one_available_tab">QUICK SHIP</div>`
    }else{
        quick_ship_tab = ``
    }

    diamond_delivery = document.getElementById("selectDelivery").options[deliveryId].innerHTML;
  
     let price = currentCurrencySymbol+''+toNumberFormat(element.total_sales_price * currentRate);
    let carat = toNumberFormat(element.size);
    let depth = toNumberFormat(element.depth);
    let table = toNumberFormat(element.table);  
    let ratio = toNumberFormat(element.ratio);

    if(element.lab === '-'){      
      element.lab = '<strong>'+element.lab+'</strong>'
    }
    let table_main_container =  document.createElement('div');
    let tableRow = document.createElement('tr');
  if(element.Column81.indexOf('d=') > -1 && element.Column81.indexOf('surl=') > -1 ||element.Column81.indexOf('.mp4') > -1 || element.Column81 != ''){
        realViewIcon = '<img  loading="lazy" src="https://cdn.shopify.com/s/files/1/0591/3663/9116/files/play.svg?v=1660072265" class="play-img"></img>';
     }else{
    if(element.image_url && element.image_url != "-" && (isV360(element.image_url) || isImage(element.image_url)) ){
        realViewIcon = '<img  loading="lazy" src="https://cdn.shopify.com/s/files/1/0591/3663/9116/files/play.svg?v=1660072265" class="play-img"></img>';
    }
    else {
        realViewIcon = '<span class="play-img"></span>';
    }
  }
    table_main_container.classList.add("main_inner_element")
    tableRow.id = 'exp-'+element.diamond_id;
    tableRow.classList.add("u-toggle");
    tableRow.setAttribute('aria-controls', element.diamond_id);
    tableRow.setAttribute('aria-expanded', 'false');
     var fluor_value= element.fluor_intensity;
  var culet_size= element.culet_size;
      if(fluor_value == '-'){
        fluor_value='None';
      }
    if(culet_size == '-'){
        culet_size='None';
      }
    tableRow.innerHTML = `<td aria-label="Quick View" scope="row" class="text-left">
      
        <div class="is-dense quickview-centeralign no-events"> 
        <svg id="arrow-table-detail" width="12" height="12" fill="currentColor" class="bi bi-chevron-down small-hide medium-hide toggle-button" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
        </svg>      
            <img  loading="lazy" src="${diamond_lineshape_img}" width="20px" height="20px">
           ${realViewIcon}
         <span class="shap_on_mobile large-up-hide">${element.shape}</span>
        </div>
    </td>
    <td aria-label="Shape" class="text-center shape small-hide medium-hide">${element.shape}</td>
    <td aria-label="Price" class="text-center tdprice">${price}</td>
    <td aria-label="Carat" class="text-center">${carat}</td>
    <td aria-label="Cut" class="text-center">${element.cut}</td>
    <td aria-label="Color" class="text-center">${element.color}</td>
    <td aria-label="Clarity" class="text-center">${element.clarity}
    <span class="toggle_button_mobile no-events large-up-hide">
    <svg id="arrow-table-detail1" width="12" height="12" fill="currentColor" class="bi bi-chevron-down large-up-hide toggle-button" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg></span></td>
    <td aria-label="Clarity" class="text-center small-hide medium-hide">${element.measurements}
    <td aria-label="Report" class="text-center small-hide medium-hide">${element.lab}</td>
    <td  class="text-center small-hide medium-hide"><div class="compare_check_box" style="color: rgb(62, 159, 142);"><label><input id="compare_product" class="hidden" type="checkbox" data-id="${element.diamond_id}"/><span class="sr-only">checkbox</span>
       <i class="icons-checkbox"></i></label></div></td>
    <td id="${element.diamond_id}" class="p-table__expanding-panel" aria-hidden="true" style="width: 100%">
        <div class="row">
            <div class="d-flex flex-row pe-0">
                <div id="dd-image">
                <h3 class="spinner" style="visibility: hidden;position: absolute;top: 50%;left: 41%;"></h3>
                    ${diamond_element_image}
                    <div class="static_tabs mobile-only large-up-hide">
                    ${quick_ship_tab}
                   
                    <div class="one_available_tab ">ONLY ONE AVAILABLE</div>
                    </div>
                </div>
                <div id="dd-info">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item table-detail-font table-detail-font-title border-0">${carat} Carat ${element.shape} Lab Grown Diamond</li>
                        <li class="list-group-item table-detail-font">${price}</li>
                        <li class="list-group-item table-detail-font">Carat: ${carat}</li>
                        <li class="list-group-item table-detail-font">Cut: ${element.cut}</li>
                        <li class="list-group-item table-detail-font">Color: ${element.color}</li>
                        <li class="list-group-item table-detail-font">Clarity: ${element.clarity}</li>
                        <li class="list-group-item table-detail-font d-flex justify-content-between align-items-center add-details-table" data-bs-toggle="collapse" data-bs-target="#details-${element.diamond_id}" aria-expanded="true" aria-controls="details-${element.diamond_id}"><span>Additional details:</li>
                            <div id="details-${element.diamond_id}" class="accordion-collapse collapse show additonaldetails-font" aria-labelledby="headingOne">
                                <div class="accordion-body px-0">
                                    <div class="row">
                                        <div style="max-width:100px;">
                                            <h5>L:W:</h5>
                                            <label>${ratio}</label>
                                        </div>
                                        <div style="max-width:110px;">
                                            <h5>Fluor:</h5>
                                            <label>${fluor_value}</label>
                                        </div>
                                        <div style="max-width:125px;">
                                            <h5>Symmetry:</h5>
                                            <label>${element.symmetry}</label>
                                        </div>
                                        <div style="max-width:90px;">
                                            <h5>Table:</h5>
                                            <label>${table}%</label>
                                        </div>                                        
                                        <div style="max-width:150px;">
                                            <h5>Measurements:</h5>
                                            <label>${element.measurements}</label>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top:23px;">
                                        <div style="max-width:100px;">
                                            <h5>Culet:</h5>
                                            <label>${culet_size}</label>
                                        </div>
                                        <div style="max-width:110px;">
                                            <h5>Polish:</h5>
                                            <label>${element.polish}</label>
                                        </div>
                                        <div style="max-width:125px;">
                                            <h5>Girdle:</h5>
                                            <label>${element.girdle}</label>
                                        </div>
                                        <div style="max-width:90px;">
                                            <h5>Depth:</h5>
                                            <label>${depth}%</label>
                                        </div>
                                        <div style="max-width:90px;">
                                            <h5>Report:</h5>
                                            <label>${element.lab}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <li class="list-group-item"></li>
                    </ul>
                     
                </div>
                <div id="dd-others" class="flex-column">
                    <div class="btnxdiamond d-flex justify-content-end">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16" aria-div="exp-${element.diamond_id}">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                        </svg>
                    </div>
                    <button id="btn-select-${element.diamond_id}" data-id="${element.diamond_id}" class="btnselectdimond btnviewdiamond">Select Diamond</button> 
                    <button id="btn-${element.diamond_id}" class="btnviewdiamond-anchor">View Diamond</button>     
                    <div class="static_tabs small-hide medium-hide">
                    ${quick_ship_tab}
                    
                    <div class="one_available_tab ">ONLY ONE AVAILABLE</div>
                    
                    
                    </div>
                </div>
            </div>
        </div>
</td>`;

   // <a class="btnviewdiamond" href="${detailURL}">View Diamond</a>
 
    document.getElementById('table-results').tBodies[0].appendChild(tableRow);
    document.getElementById(`btn-${element.diamond_id}`).addEventListener('click', event => {    
        setLocalStorageId(element.diamond_id,diamond_image_url);
      let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
      var allowed_shap = []
      if(wizardInfo != null){
          var allowed_shapes =  localStorage.getItem("setting_allowed_shapes");
        if(allowed_shapes != null){
              var allowed_shap =  localStorage.getItem("setting_allowed_shapes").split(',');
        }
        
              if(allowed_shap != null){
                wizardInfo['setting_allowed_shapes'] = allowed_shap;
                localStorage.removeItem("setting_allowed_shapes");
              }
           
             }
     
      window.location.href = window.location.origin + '/pages/diamond-detail-new?did=' + element.diamond_id;
      
    });
   if(pagination == true){
    //document.getElementById('list-view').style.height= "750px"
  }
setTimeout(function(){
var diamonds_store = localStorage.getItem("comparison_diamonds");
  if(diamonds_store != null){
var diamonds_store1 = diamonds_store.split(',');
$(diamonds_store1).each(function(){
$('input#compare_product[data-id="'+this+'"]').attr('checked',true);
$('input#compare_product[data-id="'+this+'"]').parents('.compare_check_box').find('i').removeClass('icons-checkbox');
$('input#compare_product[data-id="'+this+'"]').parents('.compare_check_box').find('i').addClass('icons-checked');
})
  }
},500)
}

//#endregion

//#region Pagination

function getNumberOfPages(npage, totalOfPages) {
    document.getElementById('npage').textContent = npage;
    document.getElementById('npages').textContent = totalOfPages;
}

function callPage(obj, npage) {
let pagination =true;
    document.querySelectorAll('.selected-page')[0].classList.remove('selected-page');
    obj.parentElement.classList.add('selected-page');

    let sortby;
    let sortDirection;

    let viewSelected = document.getElementById('selectView').options[selectView.selectedIndex].value;
    if (viewSelected === 'list') {
        
        let sort_config_table = getSortConfigTableResults();
        sortby = sort_config_table[0];
        sortDirection = sort_config_table[1];
    }
    else {
        
        let sort_config_grid = getConfigSortGrid();
        sortby = sort_config_grid[0];
        sortDirection = sort_config_grid[1];
    }   
    
    // let col = [].slice.call(table.tHead.rows[0].cells).indexOf(header);
    // let sort_by = getSortByTableResults(col);
    
    
    // Set the new header sort.
    getResults(npage,pagination);
}

function createPaginationPages(currentPage, totalOfPages) {

    let pagElements = [];
    let paginationUL = document.getElementById('pagination-zone-nav');
    paginationUL.classList.remove('justify-content-between', 'justify-content-center');

    if (currentPage != 1) {
        let prevArrow = document.createElement('li');
        prevArrow.classList.add('page-item');
        prevArrow.innerHTML = `<a onclick="callPage(this, ${currentPage - 1})" aria-label="Previous">
            <svg width="12" height="12" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
            </svg>
        </a>`;

        paginationUL.appendChild(prevArrow);
    }

    if (totalOfPages === 1) {
        paginationUL.classList.add('justify-content-center');
    }
    else {
        paginationUL.classList.add('justify-content-between');
    }

    if (totalOfPages < 5) {
        for (let index = 1; index < totalOfPages + 1; index++) {
            pagElements.push(index);
        }
    }
    else {
        pagElements = [currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2];

        if (currentPage === 1 || currentPage === 2 || totalOfPages === 5) {
            pagElements = [1, 2, 3, 4, 5];
        }

        if (currentPage === (totalOfPages - 1) || currentPage === totalOfPages) {
            pagElements = [totalOfPages - 4, totalOfPages - 3, totalOfPages - 2, totalOfPages - 1, totalOfPages];
        }
    }
    pagElements.forEach(page => {
        let li = document.createElement('li');
        li.classList.add('page-item');
        if (page === currentPage) li.classList.add('selected-page');
        li.innerHTML = `<a onclick="callPage(this, ${page})">${page}</a>`;
        paginationUL.appendChild(li);
    });

    if (currentPage != totalOfPages) {
        let nextArrow = document.createElement('li');
        nextArrow.classList.add('page-item');
        nextArrow.innerHTML = `<a onclick="callPage(this, ${currentPage + 1})" aria-label="Next">
            <svg width="12" height="12" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </a>`;

        paginationUL.appendChild(nextArrow);
    }
}

//#endregion

//#region Delivery Select 

function initDeliveryFilter() {
    
    let deliverySelect, i, j, lenDeliverSelect, lenSelectedElement, selectedElement, selectItemDiv, optionDiv, optionItemDiv;
    
    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let currentDay = new Date();
    let minDeliveryDay = new Date(currentDay.setDate(currentDay.getDate() + 6));

    deliverySelect = document.getElementsByClassName("custom-select");
    
    let sel = document.createElement('select');
    sel.setAttribute('id', 'selectDelivery');
    
    for (let index = 0; index < 12; index++) {
        
        var opt = document.createElement('option');
        opt.setAttribute('value', index);
        
        if (index != 0 && index != 11) {
            opt.innerHTML = `${days[minDeliveryDay.getDay()]}, ${months[minDeliveryDay.getMonth()]} ${minDeliveryDay.getDate()}`;
            minDeliveryDay.setDate(minDeliveryDay.getDate() + 1);
        }
        else {
            if (index === 0)
                opt.innerHTML = 'On or Before'
            else if(index === 11)
                opt.innerHTML = 'Any Date'
        }
        sel.appendChild(opt);
    }

    deliverySelect[0].appendChild(sel);

    /* Look for any elements with the class "custom-select": */
    deliverySelect = document.getElementsByClassName("custom-select");
    lenDeliverSelect = deliverySelect.length;
    
    for (i = 0; i < lenDeliverSelect; i++) {
        
        selectedElement = deliverySelect[i].getElementsByTagName("select")[0];
        
        lenSelectedElement = selectedElement.length;
        
        /* For each element, create a new DIV that will act as the selected item: */
        selectItemDiv = document.createElement("div");
        
        selectItemDiv.setAttribute("class", "select-selected");
        
        selectItemDiv.innerHTML = selectedElement.options[selectedElement.selectedIndex].innerHTML;
        
        deliverySelect[i].appendChild(selectItemDiv);
        
        /* For each element, create a new DIV that will contain the option list: */        
        optionDiv = document.createElement("div");
        
        optionDiv.setAttribute("class", "select-items select-hide");
        
        for (j = 1; j < lenSelectedElement; j++) {
            
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */
            optionItemDiv = document.createElement("div");
            
            optionItemDiv.innerHTML = selectedElement.options[j].innerHTML;
            
            optionItemDiv.addEventListener("click", function (e) {
                
                /* When an item is clicked, update the original select box,
                and the selected item: */
                
                var sameAsSelected, m, k, originalSelect, lastNode, lenOrigSelect, lenSameAsSelected;
                
                originalSelect = this.parentNode.parentNode.getElementsByTagName("select")[0];
                
                lenOrigSelect = originalSelect.length;
                
                lastNode = this.parentNode.previousSibling;
                
                for (m = 0; m < lenOrigSelect; m++) {
                    
                    if (originalSelect.options[m].innerHTML == this.innerHTML) {
                        
                        originalSelect.selectedIndex = m;
                        
                        lastNode.innerHTML = this.innerHTML;
                        
                        sameAsSelected = this.parentNode.getElementsByClassName("same-as-selected");
                        
                        lenSameAsSelected = sameAsSelected.length;
                        
                        for (k = 0; k < lenSameAsSelected; k++) {
                            sameAsSelected[k].removeAttribute("class");
                        }
                        
                        this.setAttribute("class", "same-as-selected");
                        
                        getDeliveryFilterValues();
                        resetSortSelectGrid();
                        getDiamonds();

                        break;
                    }
                }

                lastNode.click();
            });

            optionDiv.appendChild(optionItemDiv);
        }

        deliverySelect[i].appendChild(optionDiv);

        selectItemDiv.addEventListener("click", function (e) {
            
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
            e.stopPropagation();
            
            closeAllSelectDelivery(this);
            
            this.nextSibling.classList.toggle("select-hide");
            
            this.classList.toggle("select-arrow-active");
        });
    }
}

function closeAllSelectDelivery(elmnt) {
    
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var selectItems, selectSelected, i, lenSelectItems, lenSelectSelected, arrNo = [];
    
    selectItems = document.getElementsByClassName("select-items");
    
    selectSelected = document.getElementsByClassName("select-selected");
    
    lenSelectItems = selectItems.length;
    
    lenSelectSelected = selectSelected.length;
    
    for (i = 0; i < lenSelectSelected; i++) {
        if (elmnt == selectSelected[i]) {
            arrNo.push(i)
        } else {
            selectSelected[i].classList.remove("select-arrow-active");
        }
    }
    
    for (i = 0; i < lenSelectItems; i++) {
        if (arrNo.indexOf(i)) {
            selectItems[i].classList.add("select-hide");
        }
    }
}

//#endregion

//#region Sort Select 

function initSortSelect() {
    
    let sortSelect, i, j, lenSortSelect, lenSelectedElement, selectedElement, selectItemDiv, optionDiv, optionItemDiv;
    
    /* Look for any elements with the class "custom-select": */
    sortSelect = document.getElementsByClassName("sort-select");
    lenSortSelect = sortSelect.length;
    
    for (i = 0; i < lenSortSelect; i++) {
        
        selectedElement = sortSelect[i].getElementsByTagName("select")[0];
        
        lenSelectedElement = selectedElement.length;
        
        /* For each element, create a new DIV that will act as the selected item: */
        selectItemDiv = document.createElement("div");
        
        selectItemDiv.setAttribute("class", "sort-select-selected sort-custom-selected");
        
        selectItemDiv.innerHTML = selectedElement.options[selectedElement.selectedIndex].innerHTML;
        
        sortSelect[i].appendChild(selectItemDiv);
        
        /* For each element, create a new DIV that will contain the option list: */        
        optionDiv = document.createElement("div");
        
        optionDiv.setAttribute("class", "sort-select-items sort-select-hide");
        
        for (j = 1; j < lenSelectedElement; j++) {
            
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */
            optionItemDiv = document.createElement("div");
            
            optionItemDiv.innerHTML = selectedElement.options[j].innerHTML;
            
            optionItemDiv.addEventListener("click", function (e) {
                
                /* When an item is clicked, update the original select box,
                and the selected item: */
                
                var sameAsSelected, m, k, originalSelect, lastNode, lenOrigSelect, lenSameAsSelected;
                
                originalSelect = this.parentNode.parentNode.getElementsByTagName("select")[0];
                
                lenOrigSelect = originalSelect.length;
                
                lastNode = this.parentNode.previousSibling;
                
                for (m = 0; m < lenOrigSelect; m++) {
                    
                    if (originalSelect.options[m].innerHTML == this.innerHTML) {
                        
                        originalSelect.selectedIndex = m;
                        
                        lastNode.innerHTML = this.innerHTML;
                        
                        sameAsSelected = this.parentNode.getElementsByClassName("same-as-selected-sort");
                        
                        lenSameAsSelected = sameAsSelected.length;
                        
                        for (k = 0; k < lenSameAsSelected; k++) {
                            sameAsSelected[k].removeAttribute("class");
                        }
                        
                        this.setAttribute("class", "same-as-selected-sort");

                        let sort_config_grid = getConfigSortGrid();
                        let sortby = sort_config_grid[0];
                        let sortDirection = sort_config_grid[1];
                        getDiamonds(1, sortby, sortDirection);                            
                        
                        break;
                    }
                }

                lastNode.click();
            });

            if (j === 1) {
                
                if (optionItemDiv.hasAttribute('class')) {
                    optionItemDiv.classList.add('sort-border-firstopt');
                }
                else {
                    optionItemDiv.setAttribute('class', 'sort-border-firstopt');
                }  
            }

            optionDiv.appendChild(optionItemDiv);
        }

        sortSelect[i].appendChild(optionDiv);

        selectItemDiv.addEventListener("click", function (e) {
            $('table#table-results th.text-center').removeClass('bold-header');
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
            e.stopPropagation();
            
            closeAllSelectSort(this);
            
            this.nextSibling.classList.toggle("sort-select-hide");
            
            this.classList.toggle("sort-select-arrow-active");

            
            
        });
    }
}

function closeAllSelectSort(elmnt) {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var selectItems, selectSelected, i, lenSelectItems, lenSelectSelected, arrNo = [];
    
    selectItems = document.getElementsByClassName("sort-select-items");
    
    selectSelected = document.getElementsByClassName("sort-select-selected");
    
    lenSelectItems = selectItems.length;
    
    lenSelectSelected = selectSelected.length;
    
    for (i = 0; i < lenSelectSelected; i++) {
        if (elmnt == selectSelected[i]) {
            arrNo.push(i)
        } else {
            selectSelected[i].classList.remove("sort-select-arrow-active");
        }
    }
    
    for (i = 0; i < lenSelectItems; i++) {
        if (arrNo.indexOf(i)) {
            selectItems[i].classList.add("sort-select-hide");
        }
    }
}

//#endregion

//#region View Select 

function changeViewSelect() {
    let selectView = document.getElementById('selectView');
    let viewSelected = selectView.options[selectView.selectedIndex].value;
    sessionStorage.setItem("wizardViewSelected", viewSelected);

    if (viewSelected === 'list') {
       
        typeView='allDiamonds';

        resetHeadersTableResults();

        document.getElementById('grid-view').classList.add('hidden');
        document.getElementById('list-view').classList.remove('hidden');
        document.getElementById('divSelectSort').classList.add('hidden');
        document.getElementById('results').classList.add('container-listview'); 
        document.getElementById('btn-container-wishList').classList.add('hidden');
        document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters');
        document.getElementById("btn-reset-filters").classList.add('btn-reset-filters-max'); 

        document.getElementById('btn-group-grilla').getElementsByTagName('button')[0].classList.add('add_border');  
        document.getElementById('btn-container-wishList').getElementsByTagName('button')[0].classList.remove('add_border');
    }
    else {
      if ( typeView ==='wishList') {
        createCardGridWishList(); 
      } else {
        
        resetSortSelectGrid();
        
        document.getElementById('list-view').classList.add('hidden');
        document.getElementById('grid-view').classList.remove('hidden');
        document.getElementById('divSelectSort').classList.remove('hidden');
        document.getElementById('results').classList.remove('container-listview');
        
        document.getElementById('btn-container-wishList').classList.remove('hidden');

        document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters-max');
        document.getElementById("btn-reset-filters").classList.add('btn-reset-filters'); 
      }
      
        
    }

    getDiamonds();
}

function initViewSelect() {
    
    let viewSelect, i, j, lenViewSelect, lenSelectedElement, selectedElement, selectItemDiv, optionDiv, optionItemDiv;
    
    /* Look for any elements with the class "custom-select": */
    viewSelect = document.getElementsByClassName("view-select");
    lenViewSelect = viewSelect.length;
    
    for (i = 0; i < lenViewSelect; i++) {
        
        selectedElement = viewSelect[i].getElementsByTagName("select")[0];
        
        lenSelectedElement = selectedElement.length;
        
        /* For each element, create a new DIV that will act as the selected item: */
        selectItemDiv = document.createElement("div");
        
        selectItemDiv.setAttribute("class", "view-select-selected view-custom-selected");
        
        selectItemDiv.innerHTML = selectedElement.options[selectedElement.selectedIndex].innerHTML;
        
        viewSelect[i].appendChild(selectItemDiv);
        
        /* For each element, create a new DIV that will contain the option list: */        
        optionDiv = document.createElement("div");
        
        optionDiv.setAttribute("class", "view-select-items view-select-hide");
        
        for (j = 1; j < lenSelectedElement; j++) {
            
            /* For each option in the original select element,
            create a new DIV that will act as an option item: */
            optionItemDiv = document.createElement("div");
            
            optionItemDiv.innerHTML = selectedElement.options[j].innerHTML;
            
            optionItemDiv.addEventListener("click", function (e) {
                
                /* When an item is clicked, update the original select box,
                and the selected item: */
                
                var sameAsSelected, m, k, originalSelect, lastNode, lenOrigSelect, lenSameAsSelected;
                
                originalSelect = this.parentNode.parentNode.getElementsByTagName("select")[0];
                
                lenOrigSelect = originalSelect.length;
                
                lastNode = this.parentNode.previousSibling;
                
                for (m = 0; m < lenOrigSelect; m++) {
                    
                    if (originalSelect.options[m].innerHTML == this.innerHTML) {
                        
                        originalSelect.selectedIndex = m;
                        
                        lastNode.innerHTML = this.innerHTML;
                        
                        sameAsSelected = this.parentNode.getElementsByClassName("same-as-selected-view");
                        
                        lenSameAsSelected = sameAsSelected.length;
                        
                        for (k = 0; k < lenSameAsSelected; k++) {
                            sameAsSelected[k].removeAttribute("class");
                        }
                        
                        this.setAttribute("class", "same-as-selected-view");

                        changeViewSelect();                          
                        
                        break;
                    }
                }

                lastNode.click();
            });

            if (j === 1) {
                
                if (optionItemDiv.hasAttribute('class')) {
                    optionItemDiv.classList.add('view-border-firstopt');
                }
                else {
                    optionItemDiv.setAttribute('class', 'view-border-firstopt');
                }  
            }

            optionDiv.appendChild(optionItemDiv);
        }

        viewSelect[i].appendChild(optionDiv);

        selectItemDiv.addEventListener("click", function (e) {
     
            /* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
            e.stopPropagation();
            
            closeAllSelectView(this);
            
            this.nextSibling.classList.toggle("view-select-hide");
            
            this.classList.toggle("view-select-arrow-active");           
            
        });
    }

  let viewSelected = sessionStorage.getItem("wizardViewSelected");
  if(viewSelected != null && viewSelected == 'list') {
    document.getElementById('selectView').value = viewSelected;
    document.getElementById('grid-searchzone').style.display = "none";
    document.getElementById('grid-searchzone').classList.remove('d-flex');
    document.getElementById('divSelectSort').classList.add('hidden');
    document.getElementById('btn-container-wishList').classList.add('hidden');
    document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters');
    document.getElementById("btn-reset-filters").classList.add('btn-reset-filters-max');
    let selectSelected = document.getElementsByClassName("view-select-selected");
    if(selectSelected && selectSelected.length > 0) {
      selectSelected[0].innerHTML = 'List View';
    }
  }
}

function closeAllSelectView(elmnt) {
    
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var selectItems, selectSelected, i, lenSelectItems, lenSelectSelected, arrNo = [];
    
    selectItems = document.getElementsByClassName("view-select-items");
    
    selectSelected = document.getElementsByClassName("view-select-selected");
    
    lenSelectItems = selectItems.length;
    
    lenSelectSelected = selectSelected.length;
    
    for (i = 0; i < lenSelectSelected; i++) {
        if (elmnt == selectSelected[i]) {
            arrNo.push(i)
        } else {
            selectSelected[i].classList.remove("view-select-arrow-active");
        }
    }
    
    for (i = 0; i < lenSelectItems; i++) {
        if (arrNo.indexOf(i)) {
            selectItems[i].classList.add("view-select-hide");
        }
    }
}

//#endregion

function getResults(npage,pagination) {
    
    let sortby;
    let sortdirection;
    let viewSelected = document.getElementById('selectView').options[selectView.selectedIndex].value;

    document.getElementById('btn-group-grilla').getElementsByTagName('button')[0].classList.add('add_border');  
  document.getElementById('btn-container-wishList').getElementsByTagName('button')[0].classList.remove('add_border');
   if($('#table-results th.text-center.bold-header').length > 0){
    if (viewSelected === 'list') {
        let sort_config_table = getSortConfigTableResults();
        sortby = sort_config_table[0];
        sortdirection = sort_config_table[1];
      
    }
    else {
        resetSortSelectGrid();
        sortby = 'total_sales_price';
        sortdirection = 'ASC';
    }
   }else{
  let sort_config_grid = getConfigSortGrid()
    sortby = sort_config_grid[0];
    sortdirection = sort_config_grid[1];
   
   }
   getDiamonds(npage, sortby, sortdirection,pagination);
}

function showNoResults() {
    document.getElementById('errorzone').style.display = 'block';
    const errormsj = document.createElement('div');
    errormsj.classList.add('d-flex', 'justify-content-center');
    errormsj.innerHTML = `<h4>Unfortunately, no diamonds match the selected filters.</h4>`;
    document.getElementById('errorzone').appendChild(errormsj);
}

function getFiltersData() {
    /*
    If this starts from a Setting we need to get the boundaries of the filters from the localStorage (if they exist)
    */
    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo')); 
    let wizardStart;
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let min_allowed_carat =  initFiltValues.carat[0];
    let max_allowed_carat = initFiltValues.carat[1];
    let allowed_shapes = [];
    if(wizardStart == 'StartWithSetting'){
        max_allowed_carat = parseFloat(wizardInfo.setting_max_carat_size) + 0.10;
        min_allowed_carat = parseFloat(wizardInfo.setting_min_carat_size) - 0.10;
        allowed_shapes = wizardInfo.setting_allowed_shapes;
        filters.shapes = filters.shapes.length>0?filters.shapes:wizardInfo.setting_allowed_shapes;
    }

    let gradingFilter;
    let fluorFilter;
    let shapesFilter;
    let heartsArrowsFilter;
    let citiesFilter;
    let countryFilter;
    let = latestSearchnew = localStorage.getItem('latestSearchnew');
   

    gradingFilter = '';
    if (filters.labs.length > 0) {
        gradingFilter = `,"labs": [${filters.labs.map(item => `"${item}"`)}]`;
    }
  
    fluorFilter = '';
    if (filters.fluorescence_intensities.length > 0) {
        fluorFilter = `"fluorescence_intensities": [${filters.fluorescence_intensities.map(item => `"${item}"`)}]`;
    }
    
    shapesFilter = '';
    if (filters.shapes.length > 0) {
        if(allowed_shapes.length > 0){
            //End result shapes
            shapesFilterArray = [];
            filters.shapes.forEach(element => {
                if(allowed_shapes.includes(element)){
                    shapesFilterArray.push(element);
                }
            });
            shapesFilter = `,"Shapes": [${shapesFilterArray.map(item => `"${item}"`)}]`;

        }
        else {
            shapesFilter = `,"Shapes": [${filters.shapes.map(item => `"${item}"`)}]`;
        }
    }

    heartsArrowsFilter = '';
    if(filters.heartsandarrow != '') {
        heartsArrowsFilter = `,"brand": ${filters.heartsandarrow}`;
    }

    citiesFilter = '';
    countryFilter = '';
    if(filters.quickship != '') {
        citiesFilter = `,"cities": ${filters.quickship}`;
    }
    else {
        
        if(filters.delivery_country != '') {
            countryFilter = `,"country": ${filters.delivery_country}`;
        }

        if (filters.delivery_city != '') {
            citiesFilter = `,"cities": ${filters.delivery_city}`;
        }
    }

    // let's set the carat_min and max boundaries 
    if(filters.carat_min < min_allowed_carat){
        filters.carat_min = min_allowed_carat;
    }
    if(filters.carat_max > max_allowed_carat){
        filters.carat_max = max_allowed_carat;
    }
    // let filtersData = `{
    //     "search_type": "${filters.search_type}",     
    //     }`;

    let filtersData = `{       
        "color_from": "${filters.color_from}",
        "color_to": "${filters.color_to}",
        "clarity_from": "${filters.clarity_from}",
        "clarity_to": "${filters.clarity_to}",
        "price_total_from": "${filters.price_min}",
        "price_total_to": "${filters.price_max}",
        "cut_from": "${filters.cut_from}",
        "cut_to": "${filters.cut_to}",
        "size_from": "${filters.carat_min}",
        "size_to": "${filters.carat_max}",
        "polish_from": "${filters.polish_from}",
        "polish_to": "${filters.polish_to}",
        "symmetry_from": "${filters.symmetry_from}",
        "symmetry_to": "${filters.symmetry_to}",
        "depth_percent_from": "${filters.depth_percent_from}",
        "depth_percent_to": "${filters.depth_percent_to}",
        "table_percent_from": "${filters.table_percent_from}",
        "table_percent_to": "${filters.table_percent_to}",
        "ratio_from": "${filters.ratio_from}",
        "ratio_to": "${filters.ratio_to}",
        "realView": ${filters.realview},
        ${fluorFilter}
        ${gradingFilter}        
        ${shapesFilter}
        ${heartsArrowsFilter}
        ${citiesFilter}
        ${countryFilter}
        }`;
  
    return filtersData;
}

let fetchController = null;

async function getDiamonds(npage , sortby, sortdirection,pagination) {

   if(npage == undefined){
    npage = 1;
     }if(sortby == undefined){
     sortby = "total_sales_price"
     }if(sortdirection == undefined){
     sortdirection = "ASC"
     }
   
 
     if(pagination == true){
               document.getElementById('bottom_pagination_spinner').classList.remove('hidden');
               document.getElementById('bottom_pagination_spinner').classList.add('d-flex');  
      }
    let viewSelected = document.getElementById('selectView').options[selectView.selectedIndex].value;
    let filtersData = getFiltersData();

    document.getElementById('errorzone').innerHTML = '';
    document.getElementById('errorzone').style.display = 'none';

    document.getElementById('grid-view').innerHTML = '';
    if(pagination != true){
    document.getElementById('table-results').tBodies[0].innerHTML = '';
    }
    document.getElementById('btn-group-grilla').getElementsByTagName('button')[0].classList.add('add_border');  
    document.getElementById('btn-container-wishList').getElementsByTagName('button')[0].classList.remove('add_border');

    if (viewSelected === 'list' && pagination != true) {
        document.getElementById('list-searchzone').style.display = "flex";
      document.getElementById('btn-container-wishList').classList.add('hidden');
    }
    else if(pagination != true) {        
     
        document.getElementById('grid-searchzone').style.display = "flex";
    }

    let paginationZone = document.getElementById('pagination-zone');
    paginationZone.style.visibility = "hidden";

    if(fetchController) {
      fetchController.abort();
    }
   let url = window.API_URL + `diamonds/apiservices/new_api?page=${npage}&limit=${RESULTS_PER_PAGE}&sort_by=${sortby}&direction=${sortdirection}`;
    fetchController = new AbortController();
    console.log(filtersData)
    let gd = await fetch(url, {
        signal: fetchController.signal,
        method: 'POST',
       body: filtersData,
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM', }
    }).then(res => res.json())
        .then(response => {
         
            let diamonds = response.diamonds;
            console.log(response,'sss');
          console.log(response.search.total);
            let quant_results = document.getElementById('quant-results');
            if (response.search.total > 0) {    
                let quant_results_rapnet = response.search.total;
                let quant_pages = quant_results_rapnet > 0 ? Math.ceil(parseInt(quant_results_rapnet) / RESULTS_PER_PAGE) : 0;
                paginationZone.style.visibility = "visible";
                document.getElementById('pagination-zone-nav').innerHTML = '';
                createPaginationPages(npage, quant_pages);

                if (viewSelected === 'list') {
                    document.getElementById('list-searchzone').style.display = "none";
                    document.getElementById('list-view').classList.remove('hidden');
                    document.getElementById('grid-searchzone').classList.remove('d-flex');
                  document.getElementById('grid-searchzone').style.display = "none";
                  document.getElementById('btn-container-wishList').classList.add('hidden');
                
                }
                else {
                    document.getElementById('grid-searchzone').style.display = "none";
                    document.getElementById('grid-searchzone').classList.remove('d-flex');                    
                }
    
                quant_results.textContent = `(`+quant_results_rapnet+`)`;
                getNumberOfPages(npage, quant_pages);
               var rendom_no =  Math.floor(Math.random() * 10) + 1;
               var total_no_of_pd = 0;
                diamonds.forEach((diamond ,index)=> {
                     total_no_of_pd = total_no_of_pd+index;
                    if (viewSelected === 'list') {
                        createRowTableResults(diamond,pagination,index,rendom_no);
                   
                    }
                    else {                        
                        createCardGrid(diamond);
                    }
                });                
                  if(total_no_of_pd < 9){
                $('div#list-view').css('height','auto');
                 }else{
                   $('div#list-view').css('height','990px'); 
                 }     
            }
            else {
                quant_results.textContent = '(0)';
                paginationZone.style.visibility = "hidden";

                if (viewSelected === 'list') {
                    document.getElementById('list-view').classList.add('hidden');   
                    
                }
                else {
                    document.getElementById('grid-searchzone').style.display = "none";
                    document.getElementById('grid-searchzone').classList.remove('d-flex');                    
                }

                showNoResults();
            }
             if(pagination == true){
               document.getElementById('bottom_pagination_spinner').classList.add('hidden');
               document.getElementById('bottom_pagination_spinner').classList.remove('d-flex');  
             }
            latestSearchnew = {};
            latestSearchnew.filters = filters;
            latestSearchnew.viewSelected = viewSelected;
            latestSearchnew.sorby = sortby;
            latestSearchnew.sortDirection = sortdirection;
            if($('#bar-filter[data-name="Pear"],#bar-filter[data-name="Princess"],#bar-filter[data-name="Emerald"],#bar-filter[data-name="Marquise"],#bar-filter[data-name="Asscher"],#bar-filter[data-name="Radiant"],#bar-filter[data-name="Heart"],#bar-filter[data-name="Cushion"],#bar-filter[data-name="Oval"],#bar-filter[data-name="Round"]').length<1){
             latestSearchnew.filters.shapes = [];  
            }
            window.localStorage.setItem('latestSearchnew', JSON.stringify(latestSearchnew));
           var active_filter_no = $('.bar_filters #bar-filter').length;
           $('#btn-reset-filters .filter_count,#btn-reset-filters-2 .filter_count').text("("+active_filter_no+")");
        })
        .catch(error => console.error('Error:', error));   
}

function functionGetAllFiltersValues() {
    getPriceFilterValues();
    getCaratFilterValues();
    getColorFilterValues();
    getClarityFilterValues();
    getCutFilterValues();
    getGradingFilterValues();
    getRatioFilterValues();
    getPolishFilterValues();
    getSymmetryFilterValues();
    getFluorFilterValues();
    getDepthFilterValues();
    getTableFilterValues();
    getTypeFilterValue();
    getShapeFilterValues();
    getHeartsAndArrowFilterValues();
    getRealViewFilterValues();
    getQuickShipFilterValues();
    getDeliveryFilterValues();
}

function initMobileMoreFiltersBtn() {
    if (screen.width <= 375) {
        document.getElementById('first-filters-section').classList.add('hidden');
        document.getElementById('arrow-btnmorefilters').innerHTML = '';
        document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters');
        document.getElementById("btn-reset-filters").classList.add('btn-reset-filters-max'); 
    }
    else {
        if(document.getElementById('selectView').value != 'list') {
          document.getElementById("btn-reset-filters").classList.remove('btn-reset-filters-max'); 
          document.getElementById('btn-reset-filters').classList.add('btn-reset-filters');
        }

        document.getElementById('arrow-btnmorefilters').innerHTML = `<svg width="13" height="13" fill="#FFF" class="bi bi-caret-fill bi-caret-down-fill" viewBox="0 0 16 16">
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
            </svg>`
    }

    if (screen.width <= 850) {
        document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters');
        document.getElementById("btn-reset-filters").classList.add('btn-reset-filters-max'); 
    } else {
        if(document.getElementById('selectView').value != 'list') {
          document.getElementById("btn-reset-filters").classList.remove('btn-reset-filters-max'); 
          document.getElementById('btn-reset-filters').classList.add('btn-reset-filters');
        }
    }

    if (window.innerWidth <= 600) {
        document.getElementById('btn-group-grilla').classList.add('hidden');
        document.getElementById('btn-container-wishList').classList.add('hidden');
    } else {
        document.getElementById('btn-group-grilla').classList.remove('hidden');
        if(document.getElementById('selectView').value != 'list') {
          document.getElementById('btn-container-wishList').classList.remove('hidden');
        }
    }
}

function firsTimeCall() {
    initMobileMoreFiltersBtn();
    if(window.localStorage.getItem('latestSearchnew') != null){
        let latestSearchnew = JSON.parse(window.localStorage.getItem('latestSearchnew'));
        setFiltersValues(latestSearchnew);
    }
    else {
        functionGetAllFiltersValues();
        getDiamonds();
    }
    
}

function setFiltersValues(latestSearchnew) {
    priceSlider.noUiSlider.set([latestSearchnew.filters.price_min, latestSearchnew.filters.price_max]);
     let priceFilter = priceSlider.noUiSlider.get();
     let min_price = formatPrice(parseInt(priceFilter[0]))
     let max_price = formatPrice(parseInt(priceFilter[1]))
   if(parseInt(priceFilter[0]) > parseInt(initFiltValues.price[0]) || parseInt(priceFilter[1]) < parseInt(initFiltValues.price[1])){
     bar_filter('Price',min_price,max_price);
   }
    caratSlider.noUiSlider.set([latestSearchnew.filters.carat_min, latestSearchnew.filters.carat_max]);
     let caratFillter = caratSlider.noUiSlider.get();
    if(caratFillter[0] > initFiltValues.carat[0] || caratFillter[1] < initFiltValues.carat[1])
    {
      bar_filter('Carat',caratFillter[0].toString(),caratFillter[1].toString());
    }
    let clarityValues = ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF'];
    claritySlider.noUiSlider.set([clarityValues.indexOf(latestSearchnew.filters.clarity_from),clarityValues.indexOf(latestSearchnew.filters.clarity_to)+1]);
    let clarityFilter = claritySlider.noUiSlider.get();
    if(clarityValues[parseInt(clarityFilter[1])>0?parseInt(clarityFilter[1])-1:0] != 'IF' || clarityValues[parseInt(clarityFilter[0])>0?parseInt(clarityFilter[0]):0] != 'SI2'){
     bar_filter('Clarity',clarityValues[parseInt(clarityFilter[0])>0?parseInt(clarityFilter[0]):0],clarityValues[parseInt(clarityFilter[1])>0?parseInt(clarityFilter[1])-1:0]);
     }
    let colorValues = ['J', 'I', 'H', 'G', 'F', 'E', 'D'];
    colorSlider.noUiSlider.set([colorValues.indexOf(latestSearchnew.filters.color_to), colorValues.indexOf(latestSearchnew.filters.color_from)+1]);
    let colorFilter = colorSlider.noUiSlider.get();
    if(colorValues[parseInt(colorFilter[1])>0?parseInt(colorFilter[1])-1:0] != 'D' || colorValues[parseInt(colorFilter[0])>0?parseInt(colorFilter[0]):0] !='J')
    {
      bar_filter('Color',colorValues[parseInt(colorFilter[0])>0?parseInt(colorFilter[0]):0],colorValues[parseInt(colorFilter[1])>0?parseInt(colorFilter[1])-1:0]);
    }
    let cutValues = ['Fair', 'Good', 'Very Good', 'Excellent','Ideal'];
    cutSlider.noUiSlider.set([cutValues.indexOf(latestSearchnew.filters.cut_from), cutValues.indexOf(latestSearchnew.filters.cut_to)+1]);
    let cutFilter = cutSlider.noUiSlider.get();
    if(cutValues[parseInt(cutFilter[0])>0?parseInt(cutFilter[0]):0] != 'Fair' || cutValues[parseInt(cutFilter[1])>0?parseInt(cutFilter[1])-1:0] != 'Ideal'){
        bar_filter('Cut',cutValues[parseInt(cutFilter[0])>0?parseInt(cutFilter[0]):0],cutValues[parseInt(cutFilter[1])>0?parseInt(cutFilter[1])-1:0]);
    }
    ratioSlider.noUiSlider.set([latestSearchnew.filters.ratio_from, latestSearchnew.filters.ratio_to]);
    let ratioFillter = ratioSlider.noUiSlider.get();
    if( ratioFillter[0] > initFiltValues.ratio[0] || ratioFillter[1] < initFiltValues.ratio[1]){
       bar_filter('Ratio',latestSearchnew.filters.ratio_from,latestSearchnew.filters.ratio_to);
    }
    let polishValues = ['Good', 'Very Good', 'Excellent'];
    polishSlider.noUiSlider.set([polishValues.indexOf(latestSearchnew.filters.polish_from), polishValues.indexOf(latestSearchnew.filters.polish_to)+1]);
    let polishFilter = polishSlider.noUiSlider.get();
    if(polishValues[parseInt(polishFilter[1])>0?parseInt(polishFilter[1])-1:0] != 'Excellent' || polishValues[parseInt(polishFilter[0])>0?parseInt(polishFilter[0]):0] != 'Good'){
        bar_filter('Polish',polishValues[parseInt(polishFilter[0])>0?parseInt(polishFilter[0]):0],polishValues[parseInt(polishFilter[1])>0?parseInt(polishFilter[1])-1:0]);
    }
    let symmetryValues = ['Good', 'Very Good', 'Excellent'];
    symmetrySlider.noUiSlider.set([symmetryValues.indexOf(latestSearchnew.filters.symmetry_from), symmetryValues.indexOf(latestSearchnew.filters.symmetry_to)+1]);
    let symmetryFilter = symmetrySlider.noUiSlider.get();
    if(symmetryValues[parseInt(symmetryFilter[1])>0?parseInt(symmetryFilter[1])-1:0] != 'Excellent' || symmetryValues[parseInt(symmetryFilter[0])>0?parseInt(symmetryFilter[0]):0] != 'Good'){
      bar_filter('Symmetry',symmetryValues[parseInt(symmetryFilter[0])>0?parseInt(symmetryFilter[0]):0],symmetryValues[parseInt(symmetryFilter[1])>0?parseInt(symmetryFilter[1])-1:0]);
     }
    depthSlider.noUiSlider.set([latestSearchnew.filters.depth_percent_from, latestSearchnew.filters.depth_percent_to]);
    let depthFillter = depthSlider.noUiSlider.get();
    if( depthFillter[0] > initFiltValues.depth[0] || depthFillter[1] < initFiltValues.depth[1]){
       bar_filter('Depth',depthFillter[0].toString(),depthFillter[1].toString());
    }
    tableSlider.noUiSlider.set([latestSearchnew.filters.table_percent_from, latestSearchnew.filters.table_percent_to]);
    let tableFillter = tableSlider.noUiSlider.get();
    if( tableFillter[0] > initFiltValues.table[0] || tableFillter[1] < initFiltValues.table[1]){
      bar_filter('Table',tableFillter[0].toString(),tableFillter[1].toString());
    }
    document.getElementById('realview').checked = latestSearchnew.filters.realview;
    if(latestSearchnew.filters.realview){
       bar_filter('Real View')
    }
    document.getElementById('heartarrow').checked = latestSearchnew.filters.heartsandarrow;
    if(latestSearchnew.filters.heartsandarrow){
       bar_filter('Heart & Arrow')
    }
    document.getElementById('quickship').checked = latestSearchnew.filters.quickship; 
   if(latestSearchnew.filters.quickship){
       bar_filter('Quick Ship')
    }
    latestSearchnew.filters.shapes.forEach(shape => {
        document.getElementById("shape-"+shape.toLowerCase()).checked = true;
        document.getElementById("shape-"+shape.toLowerCase()).parentNode.classList.add('active');
        bar_filter(shape);
    });
    let fluorValues = ['Very Slight', 'Slight', 'None'];
    fluorSlider.noUiSlider.set([fluorValues.indexOf(latestSearchnew.filters.fluorescence_intensities[0]), fluorValues.indexOf(latestSearchnew.filters.fluorescence_intensities[latestSearchnew.filters.fluorescence_intensities.length-1])+1]);
    let fluorFilter = fluorSlider.noUiSlider.get(); 

    if( parseInt(fluorFilter[0]) > 0 || parseInt(fluorFilter[1]) < 3){
    bar_filter('Fluor',fluorValues[parseInt(fluorFilter[0])>0?parseInt(fluorFilter[0]):0],fluorValues[parseInt(fluorFilter[1])>0?parseInt(fluorFilter[1])-1:0]);
    }
    if(latestSearchnew.filters.labs.length > 0){
    
        latestSearchnew.filters.labs.forEach(lab => {
            document.getElementById("grading-"+lab.toLowerCase()).checked = true;
            document.getElementById("grading-"+lab.toLowerCase()).parentNode.classList.add('active');
          
        bar_filter(lab);
        });
    }

  
    filters = latestSearchnew.filters;
  //  filters.labs.push('IGI');

    getDiamonds();
    
}


function bar_filter(name,filter_from,filter_to){
  if(name == 'remove'){
    $('#bar-filter').remove()
  }else{
    let hypen = '-'
    if(filter_from == undefined){
     $('#bar-filter .show_hypen').addClass('hide')
     filter_from = '' 
      hypen=''
    }
    if(filter_to == undefined){
      filter_to = ''
      hypen=''
    }


    if(filter_from == "Very Slight"){
       filter_from = 'Faint' 
    } else if(filter_from == "Slight") {
       filter_from = 'Medium' 
    }
    
    if(filter_to == "Very Slight"){
       filter_to = 'Faint' 
    } else if(filter_to == "Slight") {
       filter_to = 'Medium' 
    }


    
 $('.container-diamondresults .bar_filters').append(
    `<div class="col-2 small-hide medium-hide" id="bar-filter" data-name="${name}">
                   <div class="btn-results btn-all-results bar_filter"><span class="main_fliter_text">${filter_from} ${hypen} ${filter_to} ${name}</span>
                        <span class='clear'>x</span>
                  </div>
      </div> `)
   }
}
$(document).on('click','#bar-filter',function(){

      if($(this).attr('data-name') == 'Clarity'){
      claritySlider.noUiSlider.set(initFiltValues.clarity);
        getClarityFilterValues();
        getResults();
      
      }
    if($(this).attr('data-name') == 'Cut'){
     cutSlider.noUiSlider.set(initFiltValues.cut);
     getCutFilterValues();
      getResults();
    }
    if($(this).attr('data-name') == 'Polish')
    {
    polishSlider.noUiSlider.set(initFiltValues.polish);
     getPolishFilterValues();
     getResults();
    }
    if($(this).attr('data-name') == 'Symmetry')
    {
    symmetrySlider.noUiSlider.set(initFiltValues.symmetry);
     getSymmetryFilterValues();
     getResults();
    }
    if($(this).attr('data-name') == 'Color')
    {
    colorSlider.noUiSlider.set(initFiltValues.color);
     getColorFilterValues();
     getResults();
    }
    if($(this).attr('data-name') == 'Price')
    {
    priceSlider.noUiSlider.set(initFiltValues.price);
     getPriceFilterValues();
     getResults();
    }
    if($(this).attr('data-name') == 'Fluor'){
    fluorSlider.noUiSlider.set(initFiltValues.fluor);
    getFluorFilterValues();
    getResults();
    }
    if($(this).attr('data-name') == 'Table'){
    tableSlider.noUiSlider.set(initFiltValues.table);
      getTableFilterValues();
     getResults();
    }
    if($(this).attr('data-name') == 'GIA'){
    document.getElementById('grading-gia').checked = false;
    getGradingFilterValues();
    getResults();
    
    }
    if($(this).attr('data-name') == 'IGI'){
    document.getElementById('grading-igi').checked = false;
    getGradingFilterValues();
    getResults();
    
    }
    if($(this).attr('data-name') == 'HRD'){
    document.getElementById('grading-hrd').checked = false;
    getGradingFilterValues();
    getResults();
    
    }
    if($(this).attr('data-name') == 'Depth'){
    depthSlider.noUiSlider.set(initFiltValues.depth);
    getDepthFilterValues();
    getResults();
    }
    if($(this).attr('data-name') == 'Ratio'){
      ratioSlider.noUiSlider.set(initFiltValues.ratio);
      getRatioFilterValues();
      getResults();
    }
   if($(this).attr('data-name') == 'Princess'){
     document.getElementById('shape-princess').checked = false;
     getShapeFilterValues();
     getResults();
   }
   if($(this).attr('data-name') == 'Pear'){
     document.getElementById('shape-pear').checked = false;
     getShapeFilterValues();
     getResults();
   }
   if($.trim($(this).attr('data-name')) == 'Round'){
     document.getElementById('shape-round').checked = false;
     getShapeFilterValues();
     getResults();
   }
   if($(this).attr('data-name') == 'Oval'){
     document.getElementById('shape-oval').checked = false;
     getShapeFilterValues();
     getResults();
   }
  if($(this).attr('data-name') == 'Cushion'){
    document.getElementById('shape-cushion').checked = false;
    getShapeFilterValues();
    getResults();
  }
  if($(this).attr('data-name') == 'Emerald'){
    document.getElementById('shape-emerald').checked = false;
    getShapeFilterValues();
    getResults();
   }
  if($(this).attr('data-name') == 'Marquise'){
    document.getElementById('shape-marquise').checked = false;
    getShapeFilterValues();
    getResults();
  }
  if($(this).attr('data-name') == 'Asscher'){
    document.getElementById('shape-asscher').checked = false;
    getShapeFilterValues();
    getResults();
  }
   if($(this).attr('data-name') == 'Radiant'){
     document.getElementById('shape-radiant').checked = false;
     getShapeFilterValues();
     getResults();
   }
  if($(this).attr('data-name') == 'Heart'){
    document.getElementById('shape-heart').checked = false;
     getShapeFilterValues();
     getResults();
  }
  if($(this).attr('data-name') == 'Quick Ship'){
    document.getElementById('quickship').checked = false;
    getQuickShipFilterValues();
    getResults();
  }
  if($(this).attr('data-name') == 'Real View'){
    document.getElementById('realview').checked = false;
    getRealViewFilterValues();
    getResults();
  }
   if($(this).attr('data-name') == 'Heart & Arrow'){
    document.getElementById('heartarrow').checked = false;
    getHeartsAndArrowFilterValues();
    getResults();
  }
  if($(this).attr('data-name') == 'Carat'){
    caratSlider.noUiSlider.set(initFiltValues.carat);
    getCaratFilterValues();
    getResults();
  }
  if($(this).attr('data-name') == 'Delivery'){
     $(this).remove();
    resetDeliveryFilter();
    getDeliveryFilterValues();
    getResults();
  }
})

function setLocalStorageId(stone_id,img) {
    let wizardInfo = localStorage.getItem('wizardInfo');    
    
   // localStorage.removeItem('wizardInfo');

    if (wizardInfo != null) {        
        wizardInfo = JSON.parse(wizardInfo);
        wizardInfo.stone_id = stone_id;
        wizardInfo.stone_image_url = img;

      var allowed_shap = []
      if(wizardInfo != null){
          var  allowed_shapes = localStorage.getItem("setting_allowed_shapes");
          var  max_carat_size = localStorage.getItem("setting_max_carat_size");
          var  min_carat_size = localStorage.getItem("setting_min_carat_size");
 
         if(max_carat_size != null && min_carat_size != null){
           wizardInfo['setting_max_carat_size'] = max_carat_size;
           wizardInfo['setting_min_carat_size'] = min_carat_size;
            localStorage.removeItem("setting_min_carat_size");
            localStorage.removeItem("setting_max_carat_size");
         }
          if(allowed_shapes != null){
              var allowed_shap =  localStorage.getItem("setting_allowed_shapes").split(',');
          }
             if(allowed_shap != null){
                wizardInfo['setting_allowed_shapes'] = allowed_shap;
               localStorage.removeItem("setting_allowed_shapes");
               }
         
             }
    }
    else {
        wizardInfo = window.wizard;
        wizardInfo.stone_id = stone_id;
        wizardInfo.stone_image_url = img;
    }

    localStorage.setItem("wizardInfo", JSON.stringify(wizardInfo));
}

function handleResize() {
    if (window.innerWidth <= 375) {
        document.getElementById('first-filters-section').classList.add('hidden');
        document.getElementById('arrow-btnmorefilters').innerHTML = '';

       
        document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters');
        document.getElementById("btn-reset-filters").classList.add('btn-reset-filters-max'); 
    }
    else {
        if(document.getElementById('selectView').value != 'list') {
          document.getElementById("btn-reset-filters").classList.remove('btn-reset-filters-max'); 
          document.getElementById('btn-reset-filters').classList.add('btn-reset-filters');
        }

        document.getElementById('arrow-btnmorefilters').innerHTML = `<svg width="13" height="13" fill="#FFF" class="bi bi-caret-fill bi-caret-down-fill" viewBox="0 0 16 16">
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
            </svg>`
    }

    if (window.innerWidth <= 850) {
        document.getElementById('btn-reset-filters').classList.remove('btn-reset-filters');
        document.getElementById("btn-reset-filters").classList.add('btn-reset-filters-max'); 
    } else {
        if(document.getElementById('selectView').value != 'list') {
          document.getElementById("btn-reset-filters").classList.remove('btn-reset-filters-max'); 
          document.getElementById('btn-reset-filters').classList.add('btn-reset-filters');
        }
    }

    if (window.innerWidth <= 600) {
        document.getElementById('btn-group-grilla').classList.add('hidden');
        document.getElementById('btn-container-wishList').classList.add('hidden');
    } else {
        document.getElementById('btn-group-grilla').classList.remove('hidden');
        if(document.getElementById('selectView').value != 'list') {
          document.getElementById('btn-container-wishList').classList.remove('hidden');
        }
    }
}
function compare_dimond(){
  $('.compare_data #list-view').removeClass('hidden');
    $('.result_container div#results').addClass('hidden');
   var diamonds_store = localStorage.getItem("comparison_diamonds");
if(diamonds_store.indexOf(',') > -1){
var diamonds_store1 = diamonds_store.split(',');
  $(diamonds_store1).each(function(e,index){

let url = window.API_URL +`diamonds/apiservices/new_api/${this}`; 
  let diamond;
  var result = fetch(url, {
        method: 'GET',
        headers: {'Content-Type': 'application/json','X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM'},            
    }).then(res => res.json())
     .then(async result => {          
       diamonds = result;
       createRowTableCompare_products(diamonds,e);
   }).catch(error => console.error('Error:', error));  
}); 
}else{
var diamonds_store2 = diamonds_store;
  let url = window.API_URL +`diamonds/apiservices/new_api/${diamonds_store2}`; 
  let diamond;
  var result = fetch(url, {
        method: 'GET',
        headers: {'Content-Type': 'application/json','X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM'},            
    }).then(res => res.json())
     .then(async result => {          
       diamonds = result;
       createRowTableCompare_products(diamonds);
   }).catch(error => console.error('Error:', error));  
}
$('.compare_data tr.u-toggle-compare').remove();

}
function compare_checkbox(t){
var data_id = $(t).attr('data-id');
var data_id1 = $(t).attr('data-id');
if($(t).is(':checked')){
var diamonds_store = localStorage.getItem("comparison_diamonds");
    if(diamonds_store != null){
    data_id = diamonds_store+','+data_id;
    }
   localStorage.setItem("comparison_diamonds", data_id);
   $(t).parents('.compare_check_box').find('i').removeClass('icons-checkbox');
   $(t).parents('.compare_check_box').find('i').addClass('icons-checked');
}else
{
var diamonds_store = localStorage.getItem("comparison_diamonds");
if(diamonds_store.indexOf(',') > -1){
   var dimonds_store_value = diamonds_store.split(',');
  dimonds_store_value = jQuery.grep(dimonds_store_value, function(value) {
   return value != data_id;
});
 localStorage.setItem("comparison_diamonds", dimonds_store_value);
}else{
  localStorage.removeItem("comparison_diamonds");
}
if($(t).parents().hasClass('compare_data')){
$(t).parents('.u-toggle-compare').remove();
}
$('.compare_data div#list-view tbody .u-toggle-compare[aria-controls="'+data_id1+'"]').remove();
  $(t).parents('.compare_check_box').find('i').addClass('icons-checkbox');
  $(t).parents('.compare_check_box').find('i').removeClass('icons-checked');
}
var diamonds_store = localStorage.getItem("comparison_diamonds");
if(diamonds_store != null ){
 if(diamonds_store.indexOf(',')){
 diamonds_store = diamonds_store.split(',');
 var diamonds_store_len = diamonds_store.length;
 $('.container-diamondresults .btn-group .compare_button .compare_number').text(diamonds_store_len);
}
}else{
 $('.container-diamondresults .btn-group .compare_button .compare_number').text(0);
}
}
window.addEventListener("resize", handleResize);
window.addEventListener("load", handleResize);
  
createFilters();
configTableResults();
initDeliveryFilter(); 
initSortSelect();
initViewSelect();
bindEvents();
firsTimeCall();
setTimeout(()=>{
  wishListOnlyDiamond();     
},2500);
jQuery(function($) {
    $('div#list-view').on('scroll', function() {
        if($(this).scrollTop() + $(this).innerHeight()+30 >= $(this)[0].scrollHeight) {
        if(!$('div#pagination-zone ul#pagination-zone-nav li.page-item:last').hasClass('selected-page')){
         $('div#pagination-zone ul#pagination-zone-nav li.page-item a:last').trigger('click');
         $('.bottom_pagination_spinner').addClass('d-flex');
         $('div#pagination-zone ul#pagination-zone-nav li.page-item a').attr('disabled',true);
          // Assuming you have a reference to your table container element

     }
        }
    })
});
$(document).on('change','.compare_check_box label',function(e){
e.preventDefault();
 var _this = $(this).find('#compare_product');
compare_checkbox(_this);
});
var diamonds_store = localStorage.getItem("comparison_diamonds");
 if(diamonds_store != null){
    diamonds_store = diamonds_store.split(',');
    var diamonds_store_len = diamonds_store.length;
   $('.container-diamondresults .btn-group .compare_button .compare_number').text(diamonds_store_len);
}
$('.compare_button').click(function(){
    compare_dimond(this);
});
$(document).on('click','.compare_data .u-toggle-compare td:not(.p-table__expanding-panel, .compare_check_box)',function(e){
       e.preventDefault();
        if($(this).parents('.u-toggle-compare').attr('aria-expanded')==='true'){
           //alert("true");
           $(this).parents('.u-toggle-compare').attr('aria-expanded','false');
           $(this).parents('.u-toggle-compare').find('.p-table__expanding-panel').attr('aria-hidden','true');
           $(this).parents('.u-toggle-compare').find('#arrow-table-detail-compare').removeClass('bi-chevron-up').addClass('bi-chevron-down')
           $(this).parents('.u-toggle-compare').find('#arrow-table-detail-compare').html(`<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>`)
       }
       else{
            $(this).parents('.u-toggle-compare').attr('aria-expanded','true');  
            $(this).parents('.u-toggle-compare').find('.p-table__expanding-panel').attr('aria-hidden','false');
            $(this).parents('.u-toggle-compare').find('#arrow-table-detail-compare').addClass('bi-chevron-up').removeClass('bi-chevron-down')
            $(this).parents('.u-toggle-compare').find('#arrow-table-detail-compare').html(`<path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>`)
         
       }
});
        $(document).on('click','.p-table__expanding-panel .btnxdiamond',function(){
                    $(this).parents('.u-toggle-compare,.u-toggle').attr('aria-expanded','false');
                   $(this).parents('.u-toggle-compare,.u-toggle').find('.p-table__expanding-panel').attr('aria-hidden','true');
                   $(this).parents('.u-toggle-compare,.u-toggle').find('#arrow-table-detail-compare').removeClass('bi-chevron-up').addClass('bi-chevron-down')
                   $(this).parents('.u-toggle-compare,.u-toggle').find('#arrow-table-detail-compare').html(`<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>`)
        })
  function createRowTableCompare_products(element,index) {
    let diamond_lineshape_img;
    let diamond_image;
    let diamond_element_image;
    let diamond_delivery;
    let deliveryId; 
    let another_user_bag_tab;
    let quick_ship_tab;
     let fluor_value= element.Fluorescence_Intensity;
  let culet_size= element.Culet_Size;
      if(fluor_value == '-'){
        fluor_value='None';
      }
    if(culet_size == '-'){
        culet_size='None';
      }
     var rendom_no =  Math.floor(Math.random() * 10) + 1;
   if (rendom_no == index){
    another_user_bag_tab =  `<div class="another_cart_tab one_available_tab">IN ANOTHER USER'S BAG</div>`
    }else{
     another_user_bag_tab = '';
    }
  deliveryId = 0;
    if (element.Country != 'USA') {
        deliveryId = 11;
    }

    if (element.Country === 'USA' && element.City != 'New York') {
        deliveryId = 4;
    }

    if (element.Country === 'USA' && element.City === 'New York') {
        deliveryId = 1;
        quick_ship_tab=`<div class="quick_tab one_available_tab">QUICK SHIP</div>`
    }else{
        quick_ship_tab=``;
    }
    diamond_delivery = document.getElementById("selectDelivery").options[deliveryId].innerHTML;
    if (element.Image_URL != '') {
       diamond_image = getDiamondImageUrl1(element);
     }
    else {
    diamond_image = getDiamondLinesImgTableResults1(element.Shape);
     }
    if(element.Column81.indexOf('d=') > -1 && element.Column81.indexOf('surl=') > -1){
       
      var Videourl=element.Column81;

      if(element.Image_URL !=""){
          diamond_element_image = `<div class="main_video_container"><img class="play_btn" loading="lazy" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="${element.Image_URL}"/><iframe data-scaling="true"  seamless="seamless" data-src="${element.Column81}" src="" scrolling="no" width=420 height=420></iframe></div>`;
          diamond_element_image = `<div class="main_video_container"><img class="play_btn" loading="lazy" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="${element.Image_URL}"/><iframe data-src="${element.Column81}" src="" scrolling="no" width=420 height=420></iframe></div>`;
      } else{
          diamond_element_image = `<div class="main_video_container"><iframe data-scaling="true"  seamless="seamless" data-src="${element.Column81}" src="" scrolling="no" width=420 height=420></iframe></div>`;
          diamond_element_image = `<div class="main_video_container"><iframe data-src="${element.Column81}" src="" scrolling="no" width=420 height=420></iframe></div>`;
      }
      }else if(element.Column81.indexOf('.mp4') > -1){
      var Videourl=element.Column81;

      diamond_element_image = `<div class="main_video_container"><img class="play_btn" loading="lazy" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="https://dsv7iunirnrax.cloudfront.net/first_image_new/diamond_${element.Diamond_ID}.jpg"/><video playsinline="" width="320" height="320" poster="https://dsv7iunirnrax.cloudfront.net/first_image_new/diamond_${element.Diamond_ID}.jpg" autoplay loop muted><source src="${Videourl}" type="video/mp4"> </video></div>`;
      }
    else if(element.Column81 !=''){
       if(element.Image_URL !=""){
         
            diamond_element_image = `<div class="main_video_container"><img class="play_btn" loading="lazy" src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/download1704783926.jpg?v=1704783956"/><img class="diamond_image" src="${element.Image_URL}"/><iframe data-src="${element.Column81}" src="" scrolling="no" width=420 height=420></iframe></div>`;

       } else{
           diamond_element_image = `<div class="main_video_container"><iframe data-src="${element.Column81}" src="" scrolling="no" width=420 height=420></iframe></div>`;
    
       }  
               }
    else{
        if(isV3601(element.Image_URL) == true){
        diamond_element_image = diamond_image;
        }else{
        diamond_element_image_url = getDiamondLinesImgTableResults1(element.Shape);
        diamond_element_image = `<img  loading="lazy" src="${getDiamondLinesImgTableResults1(element.Shape)}">`;
        }
      }
    diamond_element_image_url = getDiamondLinesImgTableResults1(element.Shape);
    diamond_lineshape_img = getDiamondLinesImgTableResults1(element.Shape);
    let price = toCurrencyFormat(element.Total_Price);
    let carat = toNumberFormat(element.Weight);
    let depth = toNumberFormat(element.Depth);
    let table = toNumberFormat(element.Table);  
    let ratio = toNumberFormat(element.Ratio);
    
    if(element.Lab === ''){      
      element.Lab = '<strong>'+element.Lab+'</strong>'
    }
    let table_main_container =  document.createElement('div');
    let tableRow = document.createElement('tr');
     if(element.Column81.indexOf('d=') > -1 && element.Column81.indexOf('surl=') > -1 || element.Column81.indexOf('.mp4') > -1 || element.Column81 != ''){
        realViewIcon = '<img  loading="lazy" src="https://cdn.shopify.com/s/files/1/0591/3663/9116/files/play.svg?v=1660072265" class="play-img"></img>';
     }else{
    if(element.Image_URL && element.Image_URL != "" && (isV360(element.Image_URL) || isImage(element.Image_URL)) ){
        realViewIcon = '<img  loading="lazy" src="https://cdn.shopify.com/s/files/1/0591/3663/9116/files/play.svg?v=1660072265" class="play-img"></img>';
    }
    else {
        realViewIcon = '<span class="play-img"></span>';
    }
     }
    table_main_container.classList.add("main_inner_element")
    tableRow.id = 'exp-'+element.Diamond_ID;
    tableRow.classList.add("u-toggle-compare");
    tableRow.setAttribute('aria-controls', element.Diamond_ID);
    tableRow.setAttribute('aria-expanded', 'false');
    
    tableRow.innerHTML = `<td aria-label="Quick View" scope="row" class="text-left">
      
        <div class="is-dense quickview-centeralign no-events"> 
        <svg id="arrow-table-detail-compare" width="12" height="12" fill="currentColor" class="bi bi-chevron-down small-hide medium-hide toggle-button" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
        </svg>      
            <img  loading="lazy" src="${diamond_lineshape_img}" width="20px" height="20px">
           ${realViewIcon}
         <span class="shap_on_mobile large-up-hide">${element.Shape}</span>
        </div>
    </td>
    <td aria-label="Shape" class="text-center shape small-hide medium-hide">${element.Shape}</td>
    <td aria-label="Price" class="text-center tdprice">${price}</td>
    <td aria-label="Carat" class="text-center">${carat}</td>
    <td aria-label="Cut" class="text-center">${element.Cut}</td>
    <td aria-label="Color" class="text-center">${element.Color}</td>
    <td aria-label="Clarity" class="text-center">${element.Clarity}
    <span class="toggle_button_mobile no-events large-up-hide">
    <svg id="arrow-table-detail1" width="12" height="12" fill="currentColor" class="bi bi-chevron-down large-up-hide toggle-button" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg></span></td>
    
    <td aria-label="Report" class="text-center small-hide medium-hide">${element.Lab}</td>
    <td  class="text-center small-hide medium-hide compare_check_box"><div class="compare_check_box" style="color: rgb(62, 159, 142);"><label><input id="compare_product" class="hidden" type="checkbox" checked data-id="${element.Diamond_ID}"/><span class="sr-only">checkbox</span>
       <i class="icons-checked"></i></label></div></td>
    <td id="${element.Diamond_ID}" class="p-table__expanding-panel" aria-hidden="true" style="width: 100%">
        <div class="row">
            <div class="d-flex flex-row pe-0">
                <div id="dd-image">
                    ${diamond_element_image}
                     <div class="static_tabs mobile-only large-up-hide">
                     ${quick_ship_tab}
                 
                    <div class="one_available_tab">ONLY ONE AVAILABLE</div>
                    
                    </div>
                </div>
                <div id="dd-info">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item table-detail-font table-detail-font-title border-0">${carat} Carat ${element.Shape} Diamond</li>
                        <li class="list-group-item table-detail-font">${price}</li>
                        <li class="list-group-item table-detail-font">Carat: ${carat}</li>
                        <li class="list-group-item table-detail-font">Cut: ${element.Cut}</li>
                        <li class="list-group-item table-detail-font">Color: ${element.Color}</li>
                        <li class="list-group-item table-detail-font">Clarity: ${element.Clarity}</li>
                        <li class="list-group-item table-detail-font d-flex justify-content-between align-items-center add-details-table" data-bs-toggle="collapse" data-bs-target="#details-${element.Diamond_ID}"aria-expanded="true" aria-controls="details-${element.Diamond_ID}"><span>Additional details:</li>
                            <div id="details-${element.Diamond_ID}" class="accordion-collapse collapse show additonaldetails-font" aria-labelledby="headingOne">
                                <div class="accordion-body px-0">
                                    <div class="row">
                                        <div style="max-width:100px;">
                                            <h5>L:W:</h5>
                                            <label>${ratio}</label>
                                        </div>
                                        <div style="max-width:110px;">
                                            <h5>Fluor:</h5>
                                            <label>${fluor_value}</label>
                                        </div>
                                        <div style="max-width:125px;">
                                            <h5>Symmetry:</h5>
                                            <label>${element.Symmetry}</label>
                                        </div>
                                        <div style="max-width:90px;">
                                            <h5>Table:</h5>
                                            <label>${element.Table}%</label>
                                        </div>                                        
                                        <div style="max-width:150px;">
                                            <h5>Measurements:</h5>
                                            <label>${element.Measurements}</label>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top:23px;">
                                        <div style="max-width:100px;">
                                            <h5>Culet:</h5>
                                            <label>${culet_size}</label>
                                        </div>
                                        <div style="max-width:110px;">
                                            <h5>Polish:</h5>
                                            <label>${element.Polish}</label>
                                        </div>
                                        <div style="max-width:125px;">
                                            <h5>Girdle:</h5>
                                            <label>${element.Girdle}</label>
                                        </div>
                                        <div style="max-width:90px;">
                                            <h5>Depth:</h5>
                                            <label>${element.Depth}%</label>
                                        </div>
                                        <div style="max-width:90px;">
                                            <h5>Report:</h5>
                                            <label>${element.Lab}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <li class="list-group-item"></li>
                    </ul>
                </div>
                <div id="dd-others" class=" flex-column">
                    <div class="btnxdiamond d-flex justify-content-end">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16" aria-div="exp-${element.Diamond_ID}">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                        </svg>
                    </div>
                    <button id="btn-select-${element.Diamond_ID}" data-id="${element.Diamond_ID}" class="btnselectdimond btnviewdiamond">Select Diamond</button> 
                    <button id="btn-${element.Diamond_ID}" class="btnviewdiamond-anchor">View Diamond</button>   
                    <div class="static_tabs small-hide medium-hide">
                    ${quick_ship_tab}
                   
                    <div class="one_available_tab">ONLY ONE AVAILABLE</div>
                    
                    </div>
                </div>
            </div>
        </div>
</td>`;
  $('.compare_data #table-results tbody').append(tableRow);
$(document).on('click',`.compare_data #btn-${element.Diamond_ID}`,function(){
         setLocalStorageId(element.Diamond_ID,diamond_element_image_url);
         
        window.location.href = window.location.origin + '/pages/diamond-detail-new?did=' + element.Diamond_ID;
    
});
}
function isImage1(url) {
    if(url === undefined || url === null) return false;
    return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
}
function isV3601(url){
    if(url.indexOf('360') > -1){
        return true;
    }
    else{
        return false;
    }
}
function getDiamondImageUrl1(diamond){
    if(isImage(diamond.Image_URL)){
 
        return `<img   loading="lazy" src='${diamond.Image_URL}'/>`;
    }       
    else{
        if(isV3601(diamond.Image_URL) == true){
            //set the innerHTML to an iframe loading diamond.Image_URL
            return `<iframe data-src="${diamond.Image_URL}" src="" width=420 height=420 sandbox="allow-scripts allow-orientation-lock allow-same-origin allow-pointer-lock"></iframe>`;        
        }
        else  {
            return `<img   loading="lazy" src='${getDiamondLinesImgTableResults1(diamond.Shape)}'>`;
        }
    }
}



function getDiamondLinesImgTableResults1(shape) {
    let shapesrc;

    switch (shape) {
        case "Round":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-round.png?v=1681486955";
            break;
        case "Radiant":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-radiant.png?v=1681486955";
            break;
        case "Princess":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-princess.png?v=1681486955";
            break;
        case "Pear":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-pear.png?v=1681486486";
            break;
        case "Oval":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-oval.png?v=1681486978";
            break;
        case "Marquise":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-marquise.png?v=1681486978";
            break;
        case "Heart":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-heart.png?v=1681486978";
            break;
        case "Emerald":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-emerald.png?v=1681486979";
            break;
        case "Cushion":
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-cushion.png?v=1681486978";
            break;
        case "Asscher":
            shapesrc = "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/diamond-lines-asscher.png?v=1660072977";
            break;
        default:
            shapesrc = "https://cdn.shopify.com/s/files/1/0576/3350/5416/files/rapnet-grid-asscher.png?v=1681486978";
            break;
    }

    return shapesrc;
}
$(document).on('click','.btnselectdimond',function(){
   var diamond_step = localStorage.getItem("diamond_page_step");
         if(diamond_step == null){
         localStorage.setItem("diamond_page_step",true);
         }
 let  product_id =  $(this).attr('data-id')
 selecte_diamond_collection(product_id);
 let spinner = ` <svg class="tw-w-10 tw-h-10" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
        <g fill="none" fill-rule="evenodd">
            <g transform="translate(1 1)" stroke-width="2">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="1s"
                        repeatCount="indefinite"/>
                </path>
            </g>
        </g>
    </svg>`;
   $(this).html(spinner+' Please wait...');
 localStorage.setItem('filter_data',true);
})
function selecte_diamond_collection(product_id){
         const queryString = window.location.search;
         let urlParams = new URLSearchParams(queryString);
         let diamond_id = urlParams.get('did');
         let url = window.API_URL +`diamonds/apiservices/new_api/${product_id}`;
      
         fetch(url, {
            method: 'GET',        
            headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
         }).then(res => res.json())
          .then(async diamond => {
            processing = false;
              let delivery = calcDeliveryDate(diamond.Country, diamond.City);
              get_deliveyday(diamond);
           
            if(diamond && diamond.Diamond_ID) {
              let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
              let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
              if(wizardStart === 'StartWithDiamond'){
                  let caractDictValue = getCaratDictionaryValue1(wizardInfo.stone_carat);
                  if(wizardInfo.stone_shape.toLowerCase().includes('cushion')){
                      wizardInfo.stone_shape = 'Cushion';
                  }
                  let shapeDictValue = 'dyo_shape_'+wizardInfo.stone_shape.toLowerCase();
                  url = '/collections/engagement-ring-settings-shape-new/'+caractDictValue+'+'+shapeDictValue;
              }
              else{
                  var band_products =  localStorage.getItem("band_products");
                 if(band_products != null){
                  band_products = band_products.split(',');
                  var p_length = $(band_products).length;
                  var band_products1 = ''
                  var count = 0;
                  $(band_products).each(function (index){
                    count = count+1;
                    if(index == 0){
                    band_products1= `${band_products1}p${count}=${this}`
                    }else{
                      band_products1 = `${band_products1}&p${count}=${this}`;
                    }
                    if(count == p_length){
                  url = window.location.origin+"/pages/complete-ring-new?"+band_products1+'&product_url='+wizardInfo.setting_product_handle;
                  }
                  })
                  
                }else{
                   url = window.location.origin+"/pages/complete-ring-new?product_url="+wizardInfo.setting_product_handle;
                  }
              }
              window.location.href = url;
            } else {

              $('body').append("<div id='stock-modal'><div onclick='$(this).parent().remove();' class='stock-modal-close'>X</div>We're so sorry the diamond you selected is no longer available, please choose                     another before placing your order.</div>");
            }
              
          })
          .catch(error => console.error('Error:', error));
} 
    function get_deliveyday(diamond){
       if(diamond){
            let vendorName = diamond.Seller_Name;
            console.log(vendorName);
            if(vendorName != undefined || vendorName != null ){
              var url = window.API_URL + `diamonds/diamondShipping/singlevendorShowShipping/${vendorName}`;
              var settings = {
                  "url": url,
                  "method": "GET",
                  "async":false,
                  "timeout": 0,
                  "headers": {
                  "X-API-Key": "TSANITY121A3VG7NEMVRXXEWGM"
                  },
                };
                $.ajax(settings).done(function (response) {
                 var shipping_date = response.shipping_date;
                  if(shipping_date == undefined || shipping_date == '' || shipping_date == null){
                  var shipping_date = $('#rapnet').attr('data-days');
                  }
                 setLocalStorageId1(diamond,shipping_date);
                });
            }
            }
    }
    function calcDeliveryDate(country, city) {    
        let months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];    
    
        let nroDays = 0;
        if (country != 'USA') {
            nroDays = 10;
        }
    
        if (country === 'USA' && city != 'New York') {
            nroDays = 9;
        }
    
        if (country === 'USA' && city === 'New York') {
            nroDays = 7;
          $('.static_tabs .quick-ship').show();
        }else{
         $('.static_tabs .quick-ship').hide(); 
        }
    
        let deliveryDate = new Date();
        deliveryDate.setDate(deliveryDate.getDate() + nroDays);
    
        let month = months[deliveryDate.getMonth()];
        let day = deliveryDate.getDate().toString();
        let nroEnd = day.charAt(day.length - 1);
        
        let ordinal;
        if (day === '11' || day === '12' || day === '13') {
            ordinal = 'th.';
        }
        else {
            switch (nroEnd) {
                case '1':
                    ordinal = 'st.';
                    break;
                case '2':
                    ordinal = 'nd.';
                    break;
                case '3':
                    ordinal = 'rd.';
                    break;        
                default:
                    ordinal = 'th.';
                    break;
            }
        }
    
        let delivery = month + ' ' + day + ordinal
        return delivery;
    }
function getCaratDictionaryValue1(carat){
    // get the integer part of the carat
    // Determine the lower bound
  let lowerBound = Math.floor(carat);
//alert(lowerBound+'--'+carat);
  let remainder = carat - lowerBound;
  //alert(remainder);
  let topNumber;
  if (remainder < 0.30) {
    topNumber = lowerBound + 0.29;
  } else if (remainder < 0.46) {
    topNumber = lowerBound + 0.45;
  } else {
    topNumber = lowerBound + 0.99;
  }
//alert('get_result'+topNumber);
  // Increment the lower bound for the next range
  let increment = (lowerBound % 2 === 0) ? 0.46 : 0.53;
  if (carat > topNumber) {
    topNumber = lowerBound + increment + 0.99;
 
  }
   
  return 'dyo_carat_' + topNumber.toFixed(2).replace(".","-");
  //return 'dyo_carat_' + carat.toFixed(2).replace(".","-");

}
function setLocalStorageId1(diamond,delivery) {
   var diamond_element_image = getDiamondLinesImgTableResults1(diamond.Shape);
    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));    
    if(wizardInfo != null){
          var  allowed_shapes = localStorage.getItem("setting_allowed_shapes");
          var  max_carat_size = localStorage.getItem("setting_max_carat_size");
          var  min_carat_size = localStorage.getItem("setting_min_carat_size");
         if(max_carat_size != null && min_carat_size != null){
           wizardInfo['setting_max_carat_size'] = max_carat_size;
           wizardInfo['setting_min_carat_size'] = min_carat_size;
            localStorage.removeItem("setting_min_carat_size");
            localStorage.removeItem("setting_max_carat_size");
         }
          if(allowed_shapes != null){
              var allowed_shap =  localStorage.getItem("setting_allowed_shapes").split(',');
          }
             if(allowed_shap != null){
                wizardInfo['setting_allowed_shapes'] = allowed_shap;
               localStorage.removeItem("setting_allowed_shapes");
               }
   
              wizardInfo['page_type'] = 'new';
              wizardInfo['stone_shape'] = diamond.Shape;
              wizardInfo['stone_carat'] = diamond.Weight;
              wizardInfo['stone_price'] = diamond.Total_Price;
              wizardInfo['stone_id'] = diamond.Diamond_ID;
              wizardInfo['stone_color'] = diamond.Color;
              wizardInfo['stone_cut'] = diamond.Cut;
              wizardInfo['setting_side_carat_weight'] = diamond.Weight;
              wizardInfo['stone_image_url'] = diamond_element_image;
              wizardInfo['setting_selected_shape'] = diamond.Shape;
              wizardInfo['stone_delivery'] = delivery;
              wizardInfo['stone_clarity'] = diamond.Clarity;
              wizardInfo['vendor_name'] = diamond.Seller_Name;
              wizardInfo['stone_certificate_no'] = diamond.Certificate_Number; 
              wizardInfo['stone_certificate_type'] = diamond.Lab;
              wizardInfo['stone_vendor_name'] = diamond.Seller_Name;
              wizardInfo = JSON.stringify(wizardInfo);
        
    }
    else {
            
              wizardInfo = window.wizard;
              wizardInfo['page_type'] = 'new';
              wizardInfo['stone_shape'] = diamond.Shape;
              wizardInfo['stone_carat'] = diamond.Weight;
              wizardInfo['stone_price'] = diamond.Total_Price;
              wizardInfo['stone_id'] = diamond.Diamond_ID;
              wizardInfo['stone_color'] = diamond.Color;
              wizardInfo['stone_cut'] = diamond.Cut;
              wizardInfo['setting_side_carat_weight'] = diamond.Weight;
              wizardInfo['stone_image_url'] = diamond_element_image;
              wizardInfo['setting_selected_shape'] = diamond.Shape;
              wizardInfo['stone_delivery'] = delivery;
              wizardInfo['stone_clarity'] = diamond.Clarity;
              wizardInfo['vendor_name'] = diamond.Seller_Name;
              wizardInfo['stone_certificate_no'] = diamond.Certificate_Number; 
              wizardInfo['stone_certificate_type'] = diamond.Lab;
              wizardInfo['stone_vendor_name'] = diamond.Seller_Name;
              wizardInfo = JSON.stringify(wizardInfo);
    //wizardInfo = `{"stepId":1,"setting_variant_id":0,setting_product_name":"","setting_variant_price":0,"setting_image_url":"","selected_shape":"","setting_selected_carat_size":"","setting_stone_type":"","stone_shape":"${diamond.Shape}","stone_carat":"${diamond.Weight}","stone_price":${diamond.Total_Price},"stone_id":${diamond.Diamond_ID},"stone_image_url":"${diamond_element_image}","stone_clarity":"${diamond.Clarity}","stone_color":"${diamond.Color}","stone_cut":"${diamond.Cut}","stone_delivery":"${delivery}","setting_product_handle":"","setting_product_id":"","setting_variant_sku":"","setting_min_carat_size":0,"setting_max_carat_size":0,"setting_allowed_shapes":[],"setting_selected_shape":"","setting_selected_metal":"","setting_side_carat_weight":"${diamond.Weight}"}`
     }
    
    localStorage.setItem("wizardInfo", wizardInfo);
}
$(document).on('click','.u-toggle td:not(.p-table__expanding-panel,.main_video_container),.u-toggle-compare td:not(.p-table__expanding-panel,.main_video_container)',function(){
    if($(this).parents('.u-toggle,.u-toggle-compare').attr('aria-expanded') ==  'true'){
   $("#list-view").scrollTo(this, 500);
    }
  var _this =this
  if( $(this).parents('.u-toggle,.u-toggle-compare').find('.p-table__expanding-panel #dd-image iframe').length > 0 && $(this).parents('.u-toggle,.u-toggle-compare').find('.p-table__expanding-panel #dd-image iframe').attr('src') == ''){
    $(this).parents('.u-toggle,.u-toggle-compare').find('#dd-image .spinner').css('visibility','visible');
  }
  var video_src = $(this).parents('.u-toggle,.u-toggle-compare').find('.p-table__expanding-panel #dd-image iframe').attr('data-src');
  if($(this).parents('.u-toggle,.u-toggle-compare').find('.p-table__expanding-panel #dd-image iframe').attr('src') == ''){
    $(this).parents('.u-toggle,.u-toggle-compare').find('.p-table__expanding-panel #dd-image iframe').attr('src',video_src);
    setTimeout(function(){
    $(_this).parents('.u-toggle,.u-toggle-compare').find('#dd-image .spinner').css('visibility','hidden');
    },2000)
  }
});
$(document).on('click','.main_video_container',function(){
  $(this).find('.play_btn,.diamond_image').hide();
  if($(this).find('video').length >0 &&  $(this).find('video source').attr('src') == ''){
  var video_url = $(this).find('video').attr('data-url');
    $(this).find('video source').attr('src',video_url);
    const mediaElem = document.querySelector("video");
    mediaElem.load()
  }
})
if(window.location.href.indexOf('shape') >-1){
   var shape = window.location.href.split('shape=')[1];
    $('.shape-container-2 input:checked').trigger('click');
    $(`.shape-container-2 input#shape-${shape}`).trigger('click');
    
}